//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ClientV1 {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://siemens.pulse.cloud/api/core';
  }

  /**
   * Get All Admin Privileges, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetAdminPrivilegeListGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<AdminPrivilege[]> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/privilege/list?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetAdminPrivilegeListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetAdminPrivilegeListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AdminPrivilege[]>;
            }
          } else return _observableThrow(response_) as any as Observable<AdminPrivilege[]>;
        })
      );
  }

  protected processAdmin_GetAdminPrivilegeListGET(response: HttpResponseBase): Observable<AdminPrivilege[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AdminPrivilege[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AdminPrivilege[]>(null as any);
  }

  /**
   * Get All Admin Privileges, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetAdminPrivilegeListGET2(projectId: number, useCache?: boolean | undefined): Observable<AdminPrivilege[]> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/privilege/list?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetAdminPrivilegeListGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetAdminPrivilegeListGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AdminPrivilege[]>;
            }
          } else return _observableThrow(response_) as any as Observable<AdminPrivilege[]>;
        })
      );
  }

  protected processAdmin_GetAdminPrivilegeListGET2(response: HttpResponseBase): Observable<AdminPrivilege[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AdminPrivilege[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AdminPrivilege[]>(null as any);
  }

  /**
   * Adds the admin privilege for the user, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_SetAdminPrivilegeForUserPOST(
    userId: number,
    adminPrivilegeId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/privilege/{adminPrivilegeId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (adminPrivilegeId === undefined || adminPrivilegeId === null)
      throw new Error("The parameter 'adminPrivilegeId' must be defined.");
    url_ = url_.replace('{adminPrivilegeId}', encodeURIComponent('' + adminPrivilegeId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_SetAdminPrivilegeForUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_SetAdminPrivilegeForUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_SetAdminPrivilegeForUserPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Removes the admin privilege for a user, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_RemoveAdminPrivilegeForUserDELETE(
    userId: number,
    adminPrivilegeId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/privilege/{adminPrivilegeId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (adminPrivilegeId === undefined || adminPrivilegeId === null)
      throw new Error("The parameter 'adminPrivilegeId' must be defined.");
    url_ = url_.replace('{adminPrivilegeId}', encodeURIComponent('' + adminPrivilegeId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_RemoveAdminPrivilegeForUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_RemoveAdminPrivilegeForUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_RemoveAdminPrivilegeForUserDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Adds the admin privilege for the user, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_SetAdminPrivilegeForUserPOST2(
    userId: number,
    adminPrivilegeId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/privilege/{adminPrivilegeId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (adminPrivilegeId === undefined || adminPrivilegeId === null)
      throw new Error("The parameter 'adminPrivilegeId' must be defined.");
    url_ = url_.replace('{adminPrivilegeId}', encodeURIComponent('' + adminPrivilegeId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_SetAdminPrivilegeForUserPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_SetAdminPrivilegeForUserPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_SetAdminPrivilegeForUserPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Removes the admin privilege for a user, Auth: AdminPrivilege.UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_RemoveAdminPrivilegeForUserDELETE2(
    userId: number,
    adminPrivilegeId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/privilege/{adminPrivilegeId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (adminPrivilegeId === undefined || adminPrivilegeId === null)
      throw new Error("The parameter 'adminPrivilegeId' must be defined.");
    url_ = url_.replace('{adminPrivilegeId}', encodeURIComponent('' + adminPrivilegeId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_RemoveAdminPrivilegeForUserDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_RemoveAdminPrivilegeForUserDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_RemoveAdminPrivilegeForUserDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetProjectGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<Project> {
    let url_ = this.baseUrl + '/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Project>;
            }
          } else return _observableThrow(response_) as any as Observable<Project>;
        })
      );
  }

  protected processAdmin_GetProjectGET(response: HttpResponseBase): Observable<Project> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Project>(null as any);
  }

  /**
   * Updates a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateProjectPUT(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProjectBase | undefined
  ): Observable<ProjectBase> {
    let url_ = this.baseUrl + '/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateProjectPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateProjectPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectBase>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectBase>;
        })
      );
  }

  protected processAdmin_UpdateProjectPUT(response: HttpResponseBase): Observable<ProjectBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectBase>(null as any);
  }

  /**
   * Deletes a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteProjectDELETE(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProjectDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetProjectGET2(projectId: number, useCache?: boolean | undefined): Observable<Project> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProjectGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProjectGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Project>;
            }
          } else return _observableThrow(response_) as any as Observable<Project>;
        })
      );
  }

  protected processAdmin_GetProjectGET2(response: HttpResponseBase): Observable<Project> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Project>(null as any);
  }

  /**
   * Updates a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateProjectPUT2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: ProjectBase | undefined
  ): Observable<ProjectBase> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateProjectPUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateProjectPUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectBase>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectBase>;
        })
      );
  }

  protected processAdmin_UpdateProjectPUT2(response: HttpResponseBase): Observable<ProjectBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectBase>(null as any);
  }

  /**
   * Deletes a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteProjectDELETE2(projectId: number, useCache?: boolean | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProjectDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProjectDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProjectDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Creates a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_AddProjectPOST(
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProjectBase | undefined
  ): Observable<ProjectBase> {
    let url_ = this.baseUrl + '/admin/project?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectBase>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectBase>;
        })
      );
  }

  protected processAdmin_AddProjectPOST(response: HttpResponseBase): Observable<ProjectBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectBase>(null as any);
  }

  /**
   * Creates a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_AddProjectPOST2(useCache?: boolean | undefined, body?: ProjectBase | undefined): Observable<ProjectBase> {
    let url_ = this.baseUrl + '/v1/admin/project?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProjectPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProjectPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectBase>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectBase>;
        })
      );
  }

  protected processAdmin_AddProjectPOST2(response: HttpResponseBase): Observable<ProjectBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectBase>(null as any);
  }

  /**
   * Get All Resource Types, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetResourceTypesGET(
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceType[]> {
    let url_ = this.baseUrl + '/admin/resourcetype?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType[]>;
        })
      );
  }

  protected processAdmin_GetResourceTypesGET(response: HttpResponseBase): Observable<ResourceType[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType[]>(null as any);
  }

  /**
   * Insert Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_InsertResourceTypePOST(
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceType | undefined
  ): Observable<ResourceType> {
    let url_ = this.baseUrl + '/admin/resourcetype?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_InsertResourceTypePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_InsertResourceTypePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_InsertResourceTypePOST(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Get All Resource Types, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetResourceTypesGET2(useCache?: boolean | undefined): Observable<ResourceType[]> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType[]>;
        })
      );
  }

  protected processAdmin_GetResourceTypesGET2(response: HttpResponseBase): Observable<ResourceType[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType[]>(null as any);
  }

  /**
   * Insert Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_InsertResourceTypePOST2(
    useCache?: boolean | undefined,
    body?: ResourceType | undefined
  ): Observable<ResourceType> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_InsertResourceTypePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_InsertResourceTypePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_InsertResourceTypePOST2(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Get Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetResourceTypeGET(
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceType> {
    let url_ = this.baseUrl + '/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypeGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypeGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_GetResourceTypeGET(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Update Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateResourceTypePUT(
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceType | undefined
  ): Observable<ResourceType> {
    let url_ = this.baseUrl + '/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateResourceTypePUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateResourceTypePUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_UpdateResourceTypePUT(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Delete Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteResourceTypeDELETE(
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteResourceTypeDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteResourceTypeDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteResourceTypeDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetResourceTypeGET2(resourceTypeId: number, useCache?: boolean | undefined): Observable<ResourceType> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypeGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypeGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_GetResourceTypeGET2(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Update Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateResourceTypePUT2(
    resourceTypeId: number,
    useCache?: boolean | undefined,
    body?: ResourceType | undefined
  ): Observable<ResourceType> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateResourceTypePUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateResourceTypePUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceType>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceType>;
        })
      );
  }

  protected processAdmin_UpdateResourceTypePUT2(response: HttpResponseBase): Observable<ResourceType> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceType);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceType>(null as any);
  }

  /**
   * Delete Resource Type, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteResourceTypeDELETE2(resourceTypeId: number, useCache?: boolean | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype/{resourceTypeId}?';
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteResourceTypeDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteResourceTypeDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteResourceTypeDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get All Resource Types for project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetResourceTypeProjectAccessGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceTypeAccess[]> {
    let url_ = this.baseUrl + '/admin/resourcetype/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypeProjectAccessGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypeProjectAccessGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeAccess[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeAccess[]>;
        })
      );
  }

  protected processAdmin_GetResourceTypeProjectAccessGET(response: HttpResponseBase): Observable<ResourceTypeAccess[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeAccess[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeAccess[]>(null as any);
  }

  /**
   * Get All Resource Types for project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetResourceTypeProjectAccessGET2(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceTypeAccess[]> {
    let url_ = this.baseUrl + '/v1/admin/resourcetype/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetResourceTypeProjectAccessGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetResourceTypeProjectAccessGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeAccess[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeAccess[]>;
        })
      );
  }

  protected processAdmin_GetResourceTypeProjectAccessGET2(
    response: HttpResponseBase
  ): Observable<ResourceTypeAccess[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeAccess[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeAccess[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetProviderConnectionGETAll(
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnection[]> {
    let url_ = this.baseUrl + '/admin/providerconnection?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionGETAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionGETAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection[]>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionGETAll(response: HttpResponseBase): Observable<ProviderConnection[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_InsertProviderConnectionPOST(
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProviderConnection | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/admin/providerconnection?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_InsertProviderConnectionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_InsertProviderConnectionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_InsertProviderConnectionPOST(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  admin_GetProviderConnectionGETAll2(useCache?: boolean | undefined): Observable<ProviderConnection[]> {
    let url_ = this.baseUrl + '/v1/admin/providerconnection?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionGETAll2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionGETAll2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection[]>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionGETAll2(response: HttpResponseBase): Observable<ProviderConnection[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_InsertProviderConnectionPOST2(
    useCache?: boolean | undefined,
    body?: ProviderConnection | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/v1/admin/providerconnection?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_InsertProviderConnectionPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_InsertProviderConnectionPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_InsertProviderConnectionPOST2(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetProviderConnectionGET(
    providerConnectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/admin/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionGET(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteProviderConnectionDELETE(
    providerConnectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProviderConnectionDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProviderConnectionDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProviderConnectionDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  admin_GetProviderConnectionGET2(
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/v1/admin/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionGET2(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteProviderConnectionDELETE2(
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProviderConnectionDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProviderConnectionDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProviderConnectionDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateProviderConnectionPUT(
    providerConectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProviderConnection | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/admin/providerconnection/{providerConectionId}?';
    if (providerConectionId === undefined || providerConectionId === null)
      throw new Error("The parameter 'providerConectionId' must be defined.");
    url_ = url_.replace('{providerConectionId}', encodeURIComponent('' + providerConectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateProviderConnectionPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateProviderConnectionPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_UpdateProviderConnectionPUT(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_UpdateProviderConnectionPUT2(
    providerConectionId: number,
    useCache?: boolean | undefined,
    body?: ProviderConnection | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/v1/admin/providerconnection/{providerConectionId}?';
    if (providerConectionId === undefined || providerConectionId === null)
      throw new Error("The parameter 'providerConectionId' must be defined.");
    url_ = url_.replace('{providerConectionId}', encodeURIComponent('' + providerConectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_UpdateProviderConnectionPUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_UpdateProviderConnectionPUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processAdmin_UpdateProviderConnectionPUT2(response: HttpResponseBase): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * Add  Resource Type to Project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_AddResourceTypeToProjectPOST(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddResourceTypeToProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddResourceTypeToProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_AddResourceTypeToProjectPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Delete  Resource Type from Project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteResourceTypeFromProjectDELETE(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteResourceTypeFromProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteResourceTypeFromProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteResourceTypeFromProjectDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add  Resource Type to Project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_AddResourceTypeToProjectPOST2(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddResourceTypeToProjectPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddResourceTypeToProjectPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_AddResourceTypeToProjectPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Delete  Resource Type from Project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteResourceTypeFromProjectDELETE2(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteResourceTypeFromProjectDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteResourceTypeFromProjectDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteResourceTypeFromProjectDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Attach provider connection to Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_AddProviderconnectionToResourceTypePOST(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/admin/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProviderconnectionToResourceTypePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProviderconnectionToResourceTypePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_AddProviderconnectionToResourceTypePOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove provider connection from Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteProviderconnectionFromResourceTypeDELETE(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/admin/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProviderconnectionFromResourceTypeDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProviderconnectionFromResourceTypeDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProviderconnectionFromResourceTypeDELETE(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Attach provider connection to Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_AddProviderconnectionToResourceTypePOST2(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/admin/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProviderconnectionToResourceTypePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProviderconnectionToResourceTypePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_AddProviderconnectionToResourceTypePOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove provider connection from Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteProviderconnectionFromResourceTypeDELETE2(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/admin/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProviderconnectionFromResourceTypeDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProviderconnectionFromResourceTypeDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProviderconnectionFromResourceTypeDELETE2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get provider connection with Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetProviderConnectionInProjectGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnectionDTO[]> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/providerconnection?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionInProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionInProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnectionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnectionDTO[]>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionInProjectGET(
    response: HttpResponseBase
  ): Observable<ProviderConnectionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnectionDTO[]>(null as any);
  }

  /**
   * Get provider connection with Resource Type in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetProviderConnectionInProjectGET2(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ProviderConnectionDTO[]> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/providerconnection?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProviderConnectionInProjectGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProviderConnectionInProjectGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnectionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnectionDTO[]>;
        })
      );
  }

  protected processAdmin_GetProviderConnectionInProjectGET2(
    response: HttpResponseBase
  ): Observable<ProviderConnectionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnectionDTO[]>(null as any);
  }

  /**
   * Get project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_GetProjectPropertyGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProjectPropertyDTO[]> {
    let url_ = this.baseUrl + '/admin/project/{projectId}/property?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProjectPropertyGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProjectPropertyGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO[]>;
        })
      );
  }

  protected processAdmin_GetProjectPropertyGET(response: HttpResponseBase): Observable<ProjectPropertyDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO[]>(null as any);
  }

  /**
   * Get project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_GetProjectPropertyGET2(projectId: number, useCache?: boolean | undefined): Observable<ProjectPropertyDTO[]> {
    let url_ = this.baseUrl + '/v1/admin/project/{projectId}/property?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_GetProjectPropertyGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_GetProjectPropertyGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO[]>;
        })
      );
  }

  protected processAdmin_GetProjectPropertyGET2(response: HttpResponseBase): Observable<ProjectPropertyDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO[]>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_AddProjectPropertyPOST(
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProjectPropertyDTO | undefined
  ): Observable<ProjectPropertyDTO> {
    let url_ = this.baseUrl + '/admin/project/property?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProjectPropertyPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProjectPropertyPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO>;
        })
      );
  }

  protected processAdmin_AddProjectPropertyPOST(response: HttpResponseBase): Observable<ProjectPropertyDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  admin_PutProjectPropertyPUT(
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ProjectPropertyDTO | undefined
  ): Observable<ProjectPropertyDTO> {
    let url_ = this.baseUrl + '/admin/project/property?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_PutProjectPropertyPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_PutProjectPropertyPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO>;
        })
      );
  }

  protected processAdmin_PutProjectPropertyPUT(response: HttpResponseBase): Observable<ProjectPropertyDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_AddProjectPropertyPOST2(
    useCache?: boolean | undefined,
    body?: ProjectPropertyDTO | undefined
  ): Observable<ProjectPropertyDTO> {
    let url_ = this.baseUrl + '/v1/admin/project/property?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_AddProjectPropertyPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_AddProjectPropertyPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO>;
        })
      );
  }

  protected processAdmin_AddProjectPropertyPOST2(response: HttpResponseBase): Observable<ProjectPropertyDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  admin_PutProjectPropertyPUT2(
    useCache?: boolean | undefined,
    body?: ProjectPropertyDTO | undefined
  ): Observable<ProjectPropertyDTO> {
    let url_ = this.baseUrl + '/v1/admin/project/property?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_PutProjectPropertyPUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_PutProjectPropertyPUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectPropertyDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectPropertyDTO>;
        })
      );
  }

  protected processAdmin_PutProjectPropertyPUT2(response: HttpResponseBase): Observable<ProjectPropertyDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPropertyDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectPropertyDTO>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_DeleteProjectPropertyDELETE(
    propertyId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/admin/project/property/{propertyId}?';
    if (propertyId === undefined || propertyId === null) throw new Error("The parameter 'propertyId' must be defined.");
    url_ = url_.replace('{propertyId}', encodeURIComponent('' + propertyId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProjectPropertyDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProjectPropertyDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProjectPropertyDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add project property in a project, Auth: GlobalAdmin
   * @param useCache (optional)
   * @return Success
   */
  admin_DeleteProjectPropertyDELETE2(propertyId: number, useCache?: boolean | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/admin/project/property/{propertyId}?';
    if (propertyId === undefined || propertyId === null) throw new Error("The parameter 'propertyId' must be defined.");
    url_ = url_.replace('{propertyId}', encodeURIComponent('' + propertyId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_DeleteProjectPropertyDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_DeleteProjectPropertyDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAdmin_DeleteProjectPropertyDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves the information if the current user is a global admin or not
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  admin_IsGlobalAdminGET(
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<GetIsGlobalAdminResponse> {
    let url_ = this.baseUrl + '/admin/is-global-admin?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_IsGlobalAdminGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_IsGlobalAdminGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetIsGlobalAdminResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetIsGlobalAdminResponse>;
        })
      );
  }

  protected processAdmin_IsGlobalAdminGET(response: HttpResponseBase): Observable<GetIsGlobalAdminResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetIsGlobalAdminResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetIsGlobalAdminResponse>(null as any);
  }

  /**
   * Retrieves the information if the current user is a global admin or not
   * @param useCache (optional)
   * @return Success
   */
  admin_IsGlobalAdminGET2(useCache?: boolean | undefined): Observable<GetIsGlobalAdminResponse> {
    let url_ = this.baseUrl + '/v1/admin/is-global-admin?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdmin_IsGlobalAdminGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdmin_IsGlobalAdminGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetIsGlobalAdminResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetIsGlobalAdminResponse>;
        })
      );
  }

  protected processAdmin_IsGlobalAdminGET2(response: HttpResponseBase): Observable<GetIsGlobalAdminResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetIsGlobalAdminResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetIsGlobalAdminResponse>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  alive_CheckCoreAlive2GET(api_version?: string | undefined): Observable<string> {
    let url_ = this.baseUrl + '/core/alive?';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAlive_CheckCoreAlive2GET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAlive_CheckCoreAlive2GET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processAlive_CheckCoreAlive2GET(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Alive check
   * @param api_version (optional)
   * @return Success
   */
  alive_CheckAliveGET(api_version?: string | undefined): Observable<string> {
    let url_ = this.baseUrl + '/alive?';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAlive_CheckAliveGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAlive_CheckAliveGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processAlive_CheckAliveGET(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  caching_WritePOST(api_version?: string | undefined, body?: CacheWriteInfo | undefined): Observable<void> {
    let url_ = this.baseUrl + '/cache?';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_WritePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_WritePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCaching_WritePOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  caching_WritePOST2(body?: CacheWriteInfo | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/cache';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_WritePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_WritePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCaching_WritePOST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  caching_ReadGET(key: string, api_version?: string | undefined): Observable<CachedObject> {
    let url_ = this.baseUrl + '/cache/{key}?';
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_ReadGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_ReadGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CachedObject>;
            }
          } else return _observableThrow(response_) as any as Observable<CachedObject>;
        })
      );
  }

  protected processCaching_ReadGET(response: HttpResponseBase): Observable<CachedObject> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CachedObject);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CachedObject>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  caching_DeleteDELETE(key: string, api_version?: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/cache/{key}?';
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_DeleteDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_DeleteDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCaching_DeleteDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  caching_ReadGET2(key: string): Observable<CachedObject> {
    let url_ = this.baseUrl + '/v1/cache/{key}';
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_ReadGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_ReadGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CachedObject>;
            }
          } else return _observableThrow(response_) as any as Observable<CachedObject>;
        })
      );
  }

  protected processCaching_ReadGET2(response: HttpResponseBase): Observable<CachedObject> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CachedObject);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CachedObject>(null as any);
  }

  /**
   * @return Success
   */
  caching_DeleteDELETE2(key: string): Observable<void> {
    let url_ = this.baseUrl + '/v1/cache/{key}';
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_DeleteDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_DeleteDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCaching_DeleteDELETE2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  caching_TestGET(api_version?: string | undefined): Observable<CachedObject> {
    let url_ = this.baseUrl + '/cache/test?';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_TestGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_TestGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CachedObject>;
            }
          } else return _observableThrow(response_) as any as Observable<CachedObject>;
        })
      );
  }

  protected processCaching_TestGET(response: HttpResponseBase): Observable<CachedObject> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CachedObject);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CachedObject>(null as any);
  }

  /**
   * @return Success
   */
  caching_TestGET2(): Observable<CachedObject> {
    let url_ = this.baseUrl + '/v1/cache/test';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_TestGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_TestGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CachedObject>;
            }
          } else return _observableThrow(response_) as any as Observable<CachedObject>;
        })
      );
  }

  protected processCaching_TestGET2(response: HttpResponseBase): Observable<CachedObject> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CachedObject);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<CachedObject>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  caching_DeleteKeysDELETE(pattern: string, api_version?: string | undefined): Observable<number> {
    let url_ = this.baseUrl + '/cache/pattern/{pattern}?';
    if (pattern === undefined || pattern === null) throw new Error("The parameter 'pattern' must be defined.");
    url_ = url_.replace('{pattern}', encodeURIComponent('' + pattern));
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_DeleteKeysDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_DeleteKeysDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processCaching_DeleteKeysDELETE(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @return Success
   */
  caching_DeleteKeysDELETE2(pattern: string): Observable<number> {
    let url_ = this.baseUrl + '/v1/cache/pattern/{pattern}';
    if (pattern === undefined || pattern === null) throw new Error("The parameter 'pattern' must be defined.");
    url_ = url_.replace('{pattern}', encodeURIComponent('' + pattern));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCaching_DeleteKeysDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCaching_DeleteKeysDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processCaching_DeleteKeysDELETE2(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * Get All Categories for a project, Auth: Project
   * @param categoryId (optional)
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  category_GetCategoriesGET(
    projectId: number,
    categoryId?: number | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<Category[]> {
    let url_ = this.baseUrl + '/project/{projectId}/category?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === null) throw new Error("The parameter 'categoryId' cannot be null.");
    else if (categoryId !== undefined) url_ += 'categoryId=' + encodeURIComponent('' + categoryId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_GetCategoriesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_GetCategoriesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Category[]>;
        })
      );
  }

  protected processCategory_GetCategoriesGET(response: HttpResponseBase): Observable<Category[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category[]>(null as any);
  }

  /**
   * category to Project,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  category_AddCategoryPOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: Category | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/project/{projectId}/category?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_AddCategoryPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_AddCategoryPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_AddCategoryPOST(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * Get All Categories for a project, Auth: Project
   * @param categoryId (optional)
   * @param useCache (optional)
   * @return Success
   */
  category_GetCategoriesGET2(
    projectId: number,
    categoryId?: number | undefined,
    useCache?: boolean | undefined
  ): Observable<Category[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === null) throw new Error("The parameter 'categoryId' cannot be null.");
    else if (categoryId !== undefined) url_ += 'categoryId=' + encodeURIComponent('' + categoryId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_GetCategoriesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_GetCategoriesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Category[]>;
        })
      );
  }

  protected processCategory_GetCategoriesGET2(response: HttpResponseBase): Observable<Category[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category[]>(null as any);
  }

  /**
   * category to Project,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  category_AddCategoryPOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: Category | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_AddCategoryPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_AddCategoryPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_AddCategoryPOST2(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * Get category for a project, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  category_GetCategoryGET(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_GetCategoryGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_GetCategoryGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_GetCategoryGET(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * update category for a project, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  category_UpdateCategoryPUT(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: Category | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_UpdateCategoryPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_UpdateCategoryPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_UpdateCategoryPUT(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * delete category from a project, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  category_DeleteCategoryDELETE(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_DeleteCategoryDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_DeleteCategoryDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processCategory_DeleteCategoryDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get category for a project, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  category_GetCategoryGET2(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_GetCategoryGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_GetCategoryGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_GetCategoryGET2(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * update category for a project, Auth: Project
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  category_UpdateCategoryPUT2(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    body?: Category | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_UpdateCategoryPUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_UpdateCategoryPUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_UpdateCategoryPUT2(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * delete category from a project, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  category_DeleteCategoryDELETE2(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category/{categoryId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_DeleteCategoryDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_DeleteCategoryDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processCategory_DeleteCategoryDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * upload image to category,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param file (optional)
   * @return Success
   */
  category_UploadImageToCategoryPOST(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    file?: FileParameter | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/project/{projectId}/category/{categoryId}/upload?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_UploadImageToCategoryPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_UploadImageToCategoryPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_UploadImageToCategoryPOST(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * upload image to category,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param file (optional)
   * @return Success
   */
  category_UploadImageToCategoryPOST2(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    file?: FileParameter | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category/{categoryId}/upload?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_UploadImageToCategoryPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_UploadImageToCategoryPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_UploadImageToCategoryPOST2(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * remove image from category,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  category_DeleteImageFromCategoryDELETE(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/project/{projectId}/category/{categoryId}/imageremove?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_DeleteImageFromCategoryDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_DeleteImageFromCategoryDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_DeleteImageFromCategoryDELETE(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * remove image from category,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  category_DeleteImageFromCategoryDELETE2(
    projectId: number,
    categoryId: number,
    useCache?: boolean | undefined
  ): Observable<Category> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/category/{categoryId}/imageremove?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (categoryId === undefined || categoryId === null) throw new Error("The parameter 'categoryId' must be defined.");
    url_ = url_.replace('{categoryId}', encodeURIComponent('' + categoryId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCategory_DeleteImageFromCategoryDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCategory_DeleteImageFromCategoryDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Category>;
            }
          } else return _observableThrow(response_) as any as Observable<Category>;
        })
      );
  }

  protected processCategory_DeleteImageFromCategoryDELETE2(response: HttpResponseBase): Observable<Category> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Category);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Category>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_LogNullReferenceExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/log-null-reference-exception-error';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_LogNullReferenceExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_LogNullReferenceExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_LogNullReferenceExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_LogSecurityExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/log-security-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_LogSecurityExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_LogSecurityExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_LogSecurityExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_RaiseDefaultExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/raise-default-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_RaiseDefaultExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_RaiseDefaultExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_RaiseDefaultExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_RaiseProblemDetailsExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/raise-problem-details-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_RaiseProblemDetailsExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_RaiseProblemDetailsExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_RaiseProblemDetailsExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_RaiseUserResponseExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/raise-user-response-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_RaiseUserResponseExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_RaiseUserResponseExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_RaiseUserResponseExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_RaiseSecurtiyProblemExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/raise-security-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_RaiseSecurtiyProblemExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_RaiseSecurtiyProblemExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_RaiseSecurtiyProblemExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_RaiseInvalidOperationProblemExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/raise-invalid-operation-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_RaiseInvalidOperationProblemExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_RaiseInvalidOperationProblemExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_RaiseInvalidOperationProblemExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  errorLog_UnauthorizedAccessExceptionPOST(): Observable<void> {
    let url_ = this.baseUrl + '/v1/errors/unauthorized-access-exception';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processErrorLog_UnauthorizedAccessExceptionPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processErrorLog_UnauthorizedAccessExceptionPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processErrorLog_UnauthorizedAccessExceptionPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  languages_GetCountriesGET(): Observable<GetLanguageListResponse> {
    let url_ = this.baseUrl + '/v1/languages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLanguages_GetCountriesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLanguages_GetCountriesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetLanguageListResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetLanguageListResponse>;
        })
      );
  }

  protected processLanguages_GetCountriesGET(response: HttpResponseBase): Observable<GetLanguageListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetLanguageListResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetLanguageListResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  mailSend_CreateRequestPOST(projectId: number, body?: MailSendRequest | undefined): Observable<MailSendResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/mail';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMailSend_CreateRequestPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMailSend_CreateRequestPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MailSendResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<MailSendResponse>;
        })
      );
  }

  protected processMailSend_CreateRequestPOST(response: HttpResponseBase): Observable<MailSendResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MailSendResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<MailSendResponse>(null as any);
  }

  /**
   * Initializes user management
   * @param projectId Project ID
   * @param useCache (optional) Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  management_InitUserManagementGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ManagementInitDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/management/init?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processManagement_InitUserManagementGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processManagement_InitUserManagementGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ManagementInitDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ManagementInitDTO>;
        })
      );
  }

  protected processManagement_InitUserManagementGET(response: HttpResponseBase): Observable<ManagementInitDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ManagementInitDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ManagementInitDTO>(null as any);
  }

  /**
   * Initializes user management
   * @param projectId Project ID
   * @param useCache (optional) Whether to use caching
   * @return Success
   */
  management_InitUserManagementGET2(projectId: number, useCache?: boolean | undefined): Observable<ManagementInitDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/management/init?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processManagement_InitUserManagementGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processManagement_InitUserManagementGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ManagementInitDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ManagementInitDTO>;
        })
      );
  }

  protected processManagement_InitUserManagementGET2(response: HttpResponseBase): Observable<ManagementInitDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ManagementInitDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ManagementInitDTO>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  permission_GetPermissionGET(
    projectId: number,
    permissionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<PermissionValueDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/permission/{permissionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (permissionId === undefined || permissionId === null)
      throw new Error("The parameter 'permissionId' must be defined.");
    url_ = url_.replace('{permissionId}', encodeURIComponent('' + permissionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PermissionValueDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PermissionValueDTO[]>;
        })
      );
  }

  protected processPermission_GetPermissionGET(response: HttpResponseBase): Observable<PermissionValueDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PermissionValueDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PermissionValueDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  permission_GetPermissionGET2(
    projectId: number,
    permissionId: number,
    useCache?: boolean | undefined
  ): Observable<PermissionValueDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/permission/{permissionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (permissionId === undefined || permissionId === null)
      throw new Error("The parameter 'permissionId' must be defined.");
    url_ = url_.replace('{permissionId}', encodeURIComponent('' + permissionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PermissionValueDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PermissionValueDTO[]>;
        })
      );
  }

  protected processPermission_GetPermissionGET2(response: HttpResponseBase): Observable<PermissionValueDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PermissionValueDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PermissionValueDTO[]>(null as any);
  }

  /**
   * Get distinct values from providerconnection based on row level security
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  permission_GetDistinctValuesGET(
    projectId: number,
    rowLevelSecurityId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetDistinctValuesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetDistinctValuesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
        })
      );
  }

  protected processPermission_GetDistinctValuesGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string[] } });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: string[] } }>(null as any);
  }

  /**
   * Get distinct values from providerconnection based on row level security
   * @param useCache (optional)
   * @return Success
   */
  permission_GetDistinctValuesGET2(
    projectId: number,
    rowLevelSecurityId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetDistinctValuesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetDistinctValuesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
        })
      );
  }

  protected processPermission_GetDistinctValuesGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string[] } });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: string[] } }>(null as any);
  }

  /**
   * Get permission values from providerconnection based on row level security
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  permission_GetPermissionValuesForUserGET(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionValuesForUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionValuesForUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processPermission_GetPermissionValuesForUserGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
   * Get permission values from providerconnection based on row level security
   * @param useCache (optional)
   * @return Success
   */
  permission_GetPermissionValuesForUserGET2(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionValuesForUserGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionValuesForUserGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processPermission_GetPermissionValuesForUserGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
   * Get permission values from providerconnection based on row level security
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  permission_GetPermissionValuesForRoleGET(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionValuesForRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionValuesForRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processPermission_GetPermissionValuesForRoleGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
   * Get permission values from providerconnection based on row level security
   * @param useCache (optional)
   * @return Success
   */
  permission_GetPermissionValuesForRoleGET2(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_GetPermissionValuesForRoleGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_GetPermissionValuesForRoleGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processPermission_GetPermissionValuesForRoleGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
   * Insert permission value for providerconnection for row level security
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  permission_InsertPermissionValueForUserPOST(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_InsertPermissionValueForUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_InsertPermissionValueForUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_InsertPermissionValueForUserPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
     * Delete permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
  permission_DeletePermissionValueForUserDELETE(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_DeletePermissionValueForUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_DeletePermissionValueForUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_DeletePermissionValueForUserDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Insert permission value for providerconnection for row level security
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  permission_InsertPermissionValueForUserPOST2(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_InsertPermissionValueForUserPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_InsertPermissionValueForUserPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_InsertPermissionValueForUserPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
     * Delete permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param body (optional) 
     * @return Success
     */
  permission_DeletePermissionValueForUserDELETE2(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_DeletePermissionValueForUserDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_DeletePermissionValueForUserDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_DeletePermissionValueForUserDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  permission_InsertPermissionValueForRolePOST(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_InsertPermissionValueForRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_InsertPermissionValueForRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_InsertPermissionValueForRolePOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  permission_DeletePermissionValueForRoleDELETE(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_DeletePermissionValueForRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_DeletePermissionValueForRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_DeletePermissionValueForRoleDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  permission_InsertPermissionValueForRolePOST2(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_InsertPermissionValueForRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_InsertPermissionValueForRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_InsertPermissionValueForRolePOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  permission_DeletePermissionValueForRoleDELETE2(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/permission/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermission_DeletePermissionValueForRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermission_DeletePermissionValueForRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processPermission_DeletePermissionValueForRoleDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  preCaching_InitUserCacheForProjectAsBatchPOST(
    body?: PreCachingPayload | undefined
  ): Observable<SendMessageBatchResponse[]> {
    let url_ = this.baseUrl + '/v1/precaching/precache-users-for-project';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPreCaching_InitUserCacheForProjectAsBatchPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPreCaching_InitUserCacheForProjectAsBatchPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SendMessageBatchResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SendMessageBatchResponse[]>;
        })
      );
  }

  protected processPreCaching_InitUserCacheForProjectAsBatchPOST(
    response: HttpResponseBase
  ): Observable<SendMessageBatchResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SendMessageBatchResponse[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SendMessageBatchResponse[]>(null as any);
  }

  /**
   * Retrieves current user projects profile, Auth: Basic
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  project_GetUserProjectAccessGET(
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserProjectAccess> {
    let url_ = this.baseUrl + '/project?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetUserProjectAccessGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetUserProjectAccessGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserProjectAccess>;
            }
          } else return _observableThrow(response_) as any as Observable<UserProjectAccess>;
        })
      );
  }

  protected processProject_GetUserProjectAccessGET(response: HttpResponseBase): Observable<UserProjectAccess> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserProjectAccess);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProjectAccess>(null as any);
  }

  /**
   * Retrieves current user projects profile, Auth: Basic
   * @param useCache (optional)
   * @return Success
   */
  project_GetUserProjectAccessGET2(useCache?: boolean | undefined): Observable<UserProjectAccess> {
    let url_ = this.baseUrl + '/v1/project?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetUserProjectAccessGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetUserProjectAccessGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserProjectAccess>;
            }
          } else return _observableThrow(response_) as any as Observable<UserProjectAccess>;
        })
      );
  }

  protected processProject_GetUserProjectAccessGET2(response: HttpResponseBase): Observable<UserProjectAccess> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserProjectAccess);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProjectAccess>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  project_GetProjectGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<Project> {
    let url_ = this.baseUrl + '/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Project>;
            }
          } else return _observableThrow(response_) as any as Observable<Project>;
        })
      );
  }

  protected processProject_GetProjectGET(response: HttpResponseBase): Observable<Project> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Project>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  project_GetProjectGET2(projectId: number, useCache?: boolean | undefined): Observable<Project> {
    let url_ = this.baseUrl + '/v1/project/{projectId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Project>;
            }
          } else return _observableThrow(response_) as any as Observable<Project>;
        })
      );
  }

  protected processProject_GetProjectGET2(response: HttpResponseBase): Observable<Project> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<Project>(null as any);
  }

  /**
   * Retrieves current user access profile of logged-in user, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  project_GetProjectInitGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProjectInitDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/Init?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectInitGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectInitGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectInitDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectInitDTO>;
        })
      );
  }

  protected processProject_GetProjectInitGET(response: HttpResponseBase): Observable<ProjectInitDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectInitDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectInitDTO>(null as any);
  }

  /**
   * Retrieves current user access profile of logged-in user, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  project_GetProjectInitGET2(projectId: number, useCache?: boolean | undefined): Observable<ProjectInitDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/Init?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_GetProjectInitGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_GetProjectInitGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProjectInitDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ProjectInitDTO>;
        })
      );
  }

  protected processProject_GetProjectInitGET2(response: HttpResponseBase): Observable<ProjectInitDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectInitDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProjectInitDTO>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  project_SetupAsyncPOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: SetupProjectRequest | undefined
  ): Observable<SetupProjectResponse> {
    let url_ = this.baseUrl + '/project/{projectId}/setup?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_SetupAsyncPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_SetupAsyncPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SetupProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SetupProjectResponse>;
        })
      );
  }

  protected processProject_SetupAsyncPOST(response: HttpResponseBase): Observable<SetupProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SetupProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SetupProjectResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  project_SetupAsyncPOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: SetupProjectRequest | undefined
  ): Observable<SetupProjectResponse> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/setup?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProject_SetupAsyncPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProject_SetupAsyncPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SetupProjectResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SetupProjectResponse>;
        })
      );
  }

  protected processProject_SetupAsyncPOST2(response: HttpResponseBase): Observable<SetupProjectResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SetupProjectResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SetupProjectResponse>(null as any);
  }

  /**
   * Get Provider Connections, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionsGET(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ProviderConnection[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/providerconnection?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection[]>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionsGET(
    response: HttpResponseBase
  ): Observable<ProviderConnection[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection[]>(null as any);
  }

  /**
   * Get Provider Connections, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionsGET2(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnection[]> {
    let url_ = this.baseUrl + '/project/{projectId}/providerconnection?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionsGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionsGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection[]>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionsGET2(
    response: HttpResponseBase
  ): Observable<ProviderConnection[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection[]>(null as any);
  }

  /**
   * Get Database Connection By Id, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionByIdGET(
    providerConnectionId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionByIdGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionByIdGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionByIdGET(
    response: HttpResponseBase
  ): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * Get Database Connection By Id, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionByIdGET2(
    providerConnectionId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnection> {
    let url_ = this.baseUrl + '/project/{projectId}/providerconnection/{providerConnectionId}?';
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionByIdGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionByIdGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnection>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnection>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionByIdGET2(
    response: HttpResponseBase
  ): Observable<ProviderConnection> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnection);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnection>(null as any);
  }

  /**
   * Get Base Information of existing ProviderConnections for a project and specific resource types, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionBaseListGET(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined
  ): Observable<ProviderConnectionDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionBaseListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionBaseListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnectionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnectionDTO[]>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionBaseListGET(
    response: HttpResponseBase
  ): Observable<ProviderConnectionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnectionDTO[]>(null as any);
  }

  /**
   * Get Base Information of existing ProviderConnections for a project and specific resource types, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  providerConnection_GetProviderConnectionBaseListGET2(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ProviderConnectionDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resourcetype/{resourceTypeId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetProviderConnectionBaseListGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetProviderConnectionBaseListGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderConnectionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderConnectionDTO[]>;
        })
      );
  }

  protected processProviderConnection_GetProviderConnectionBaseListGET2(
    response: HttpResponseBase
  ): Observable<ProviderConnectionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProviderConnectionDTO[]>(null as any);
  }

  /**
   * Get List of Tables from ProviderConnectionId, Auth: ResourceType with Create or Update
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetTableListGET(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined
  ): Observable<string[]> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}/tables?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetTableListGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetTableListGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processProviderConnection_GetTableListGET(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * Get List of Tables from ProviderConnectionId, Auth: ResourceType with Create or Update
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  providerConnection_GetTableListGET2(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<string[]> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}/tables?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetTableListGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetTableListGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processProviderConnection_GetTableListGET2(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * Get List of Columns from Table, Auth: ResourceType with Create or Update
   * @param table (optional)
   * @param useCache (optional)
   * @return Success
   */
  providerConnection_GetTableColumnsGET(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    table?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<string[]> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}/columns?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (table === null) throw new Error("The parameter 'table' cannot be null.");
    else if (table !== undefined) url_ += 'table=' + encodeURIComponent('' + table) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetTableColumnsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetTableColumnsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processProviderConnection_GetTableColumnsGET(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * Get List of Columns from Table, Auth: ResourceType with Create or Update
   * @param table (optional)
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  providerConnection_GetTableColumnsGET2(
    projectId: number,
    resourceTypeId: number,
    providerConnectionId: number,
    table?: string | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<string[]> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/resourcetype/{resourceTypeId}/providerconnection/{providerConnectionId}/columns?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (providerConnectionId === undefined || providerConnectionId === null)
      throw new Error("The parameter 'providerConnectionId' must be defined.");
    url_ = url_.replace('{providerConnectionId}', encodeURIComponent('' + providerConnectionId));
    if (table === null) throw new Error("The parameter 'table' cannot be null.");
    else if (table !== undefined) url_ += 'table=' + encodeURIComponent('' + table) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetTableColumnsGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetTableColumnsGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processProviderConnection_GetTableColumnsGET2(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
     * Get distinct values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @return Success
     */
  providerConnection_GetDistinctValuesGET(
    projectId: number,
    rowLevelSecurityId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetDistinctValuesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetDistinctValuesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
        })
      );
  }

  protected processProviderConnection_GetDistinctValuesGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string[] } });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: string[] } }>(null as any);
  }

  /**
     * Get distinct values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @return Success
     */
  providerConnection_GetDistinctValuesGET2(
    projectId: number,
    rowLevelSecurityId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetDistinctValuesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetDistinctValuesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string[] } }>;
        })
      );
  }

  protected processProviderConnection_GetDistinctValuesGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: string[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string[] } });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: string[] } }>(null as any);
  }

  /**
     * Get permission values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @return Success
     */
  providerConnection_GetPermissionValuesForUserGET(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetPermissionValuesForUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetPermissionValuesForUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processProviderConnection_GetPermissionValuesForUserGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
     * Get permission values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @return Success
     */
  providerConnection_GetPermissionValuesForUserGET2(
    projectId: number,
    rowLevelSecurityId: number,
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}/user/{userId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetPermissionValuesForUserGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetPermissionValuesForUserGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processProviderConnection_GetPermissionValuesForUserGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
     * Get permission values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @return Success
     */
  providerConnection_GetPermissionValuesForRoleGET(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    useCache?: boolean | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetPermissionValuesForRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetPermissionValuesForRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processProviderConnection_GetPermissionValuesForRoleGET(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
     * Get permission values from providerconnection based on row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @return Success
     */
  providerConnection_GetPermissionValuesForRoleGET2(
    projectId: number,
    rowLevelSecurityId: number,
    roleId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    let url_ = this.baseUrl + '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityId}/role/{roleId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityId === undefined || rowLevelSecurityId === null)
      throw new Error("The parameter 'rowLevelSecurityId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityId}', encodeURIComponent('' + rowLevelSecurityId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_GetPermissionValuesForRoleGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_GetPermissionValuesForRoleGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<{
                [key: string]: { [key: string]: PermissionValueDTO[] };
              }>;
            }
          } else
            return _observableThrow(response_) as any as Observable<{
              [key: string]: { [key: string]: PermissionValueDTO[] };
            }>;
        })
      );
  }

  protected processProviderConnection_GetPermissionValuesForRoleGET2(
    response: HttpResponseBase
  ): Observable<{ [key: string]: { [key: string]: PermissionValueDTO[] } }> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as {
                  [key: string]: { [key: string]: PermissionValueDTO[] };
                });
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<{ [key: string]: { [key: string]: PermissionValueDTO[] } }>(null as any);
  }

  /**
     * Insert permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param body (optional) 
     * @return Success
     */
  providerConnection_InsertPermissionValueForUserPOST(
    projectId: number,
    rowLevelSecurityResourceId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_InsertPermissionValueForUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_InsertPermissionValueForUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_InsertPermissionValueForUserPOST(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
     * Delete permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param body (optional) 
     * @return Success
     */
  providerConnection_DeletePermissionValueForUserDELETE(
    projectId: number,
    rowLevelSecurityResourceId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_DeletePermissionValueForUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_DeletePermissionValueForUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_DeletePermissionValueForUserDELETE(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
     * Insert permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
  providerConnection_InsertPermissionValueForUserPOST2(
    projectId: number,
    rowLevelSecurityResourceId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_InsertPermissionValueForUserPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_InsertPermissionValueForUserPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_InsertPermissionValueForUserPOST2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
     * Delete permission value for providerconnection for row level security
    Maybe move to a different place?
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
  providerConnection_DeletePermissionValueForUserDELETE2(
    projectId: number,
    rowLevelSecurityResourceId: number,
    userId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/user/{userId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_DeletePermissionValueForUserDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_DeletePermissionValueForUserDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_DeletePermissionValueForUserDELETE2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_InsertPermissionValueForRolePOST(
    projectId: number,
    rowLevelSecurityResourceId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_InsertPermissionValueForRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_InsertPermissionValueForRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_InsertPermissionValueForRolePOST(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_DeletePermissionValueForRoleDELETE(
    projectId: number,
    rowLevelSecurityResourceId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/v1/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_DeletePermissionValueForRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_DeletePermissionValueForRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_DeletePermissionValueForRoleDELETE(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_InsertPermissionValueForRolePOST2(
    projectId: number,
    rowLevelSecurityResourceId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_InsertPermissionValueForRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_InsertPermissionValueForRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_InsertPermissionValueForRolePOST2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  providerConnection_DeletePermissionValueForRoleDELETE2(
    projectId: number,
    rowLevelSecurityResourceId: number,
    roleId: number,
    columnDefinitionId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: PermissionValueDTO | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/project/{projectId}/rowlevelsecurity/{rowLevelSecurityResourceId}/role/{roleId}/columnDefinition/{columnDefinitionId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (rowLevelSecurityResourceId === undefined || rowLevelSecurityResourceId === null)
      throw new Error("The parameter 'rowLevelSecurityResourceId' must be defined.");
    url_ = url_.replace('{rowLevelSecurityResourceId}', encodeURIComponent('' + rowLevelSecurityResourceId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (columnDefinitionId === undefined || columnDefinitionId === null)
      throw new Error("The parameter 'columnDefinitionId' must be defined.");
    url_ = url_.replace('{columnDefinitionId}', encodeURIComponent('' + columnDefinitionId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProviderConnection_DeletePermissionValueForRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProviderConnection_DeletePermissionValueForRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processProviderConnection_DeletePermissionValueForRoleDELETE2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  pst_GeneratePstForProjectPOST(projectId: number, useCache?: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/pst?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPst_GeneratePstForProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPst_GeneratePstForProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPst_GeneratePstForProjectPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get All Resources for a project, Auth: Project
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_GetResourcesGET(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceDTO[]>;
        })
      );
  }

  protected processResource_GetResourcesGET(response: HttpResponseBase): Observable<ResourceDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceDTO[]>(null as any);
  }

  /**
   * Add Resource to Project, Auth: Project
   * @param useCache (optional)
   * @param currentLanguage (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_AddResourcePOST(
    projectId: number,
    useCache?: boolean | undefined,
    currentLanguage?: string | undefined,
    api_version?: string | undefined,
    body?: ResourceFull | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/project/{projectId}/resource?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (currentLanguage === null) throw new Error("The parameter 'currentLanguage' cannot be null.");
    else if (currentLanguage !== undefined) url_ += 'currentLanguage=' + encodeURIComponent('' + currentLanguage) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_AddResourcePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_AddResourcePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_AddResourcePOST(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Get All Resources for a project, Auth: Project
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @return Success
   */
  resource_GetResourcesGET2(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined
  ): Observable<ResourceDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceDTO[]>;
        })
      );
  }

  protected processResource_GetResourcesGET2(response: HttpResponseBase): Observable<ResourceDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceDTO[]>(null as any);
  }

  /**
   * Add Resource to Project, Auth: Project
   * @param useCache (optional)
   * @param currentLanguage (optional)
   * @param body (optional)
   * @return Success
   */
  resource_AddResourcePOST2(
    projectId: number,
    useCache?: boolean | undefined,
    currentLanguage?: string | undefined,
    body?: ResourceFull | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (currentLanguage === null) throw new Error("The parameter 'currentLanguage' cannot be null.");
    else if (currentLanguage !== undefined) url_ += 'currentLanguage=' + encodeURIComponent('' + currentLanguage) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_AddResourcePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_AddResourcePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_AddResourcePOST2(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Get All Resources for a project, Auth: Project
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_GetResourcesFullGET(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceFull[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/full?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull[]>;
        })
      );
  }

  protected processResource_GetResourcesFullGET(response: HttpResponseBase): Observable<ResourceFull[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull[]>(null as any);
  }

  /**
   * Get All Resources for a project, Auth: Project
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @return Success
   */
  resource_GetResourcesFullGET2(
    projectId: number,
    resourceTypeId?: number[] | undefined,
    useCache?: boolean | undefined
  ): Observable<ResourceFull[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/full?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined)
      resourceTypeId &&
        resourceTypeId.forEach((item) => {
          url_ += 'resourceTypeId=' + encodeURIComponent('' + item) + '&';
        });
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourcesFullGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourcesFullGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull[]>;
        })
      );
  }

  protected processResource_GetResourcesFullGET2(response: HttpResponseBase): Observable<ResourceFull[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull[]>(null as any);
  }

  /**
   * Get Resource by resourceId, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_GetResourceGET(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceDTO>;
        })
      );
  }

  protected processResource_GetResourceGET(response: HttpResponseBase): Observable<ResourceDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceDTO>(null as any);
  }

  /**
   * Update a Resource, Auth: Resource Update
   * @param useCache (optional)
   * @param currentLanguage (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_UpdateResourcePUT(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    currentLanguage?: string | undefined,
    api_version?: string | undefined,
    body?: ResourceFull | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (currentLanguage === null) throw new Error("The parameter 'currentLanguage' cannot be null.");
    else if (currentLanguage !== undefined) url_ += 'currentLanguage=' + encodeURIComponent('' + currentLanguage) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_UpdateResourcePUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_UpdateResourcePUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_UpdateResourcePUT(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Delete Resource from Project, Auth: Resource, ActionId: 1
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_DeleteResourceDELETE(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_DeleteResourceDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_DeleteResourceDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_DeleteResourceDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @return Success
   */
  resource_GetResourceGET2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceDTO>;
        })
      );
  }

  protected processResource_GetResourceGET2(response: HttpResponseBase): Observable<ResourceDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceDTO>(null as any);
  }

  /**
   * Update a Resource, Auth: Resource Update
   * @param useCache (optional)
   * @param currentLanguage (optional)
   * @param body (optional)
   * @return Success
   */
  resource_UpdateResourcePUT2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    currentLanguage?: string | undefined,
    body?: ResourceFull | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (currentLanguage === null) throw new Error("The parameter 'currentLanguage' cannot be null.");
    else if (currentLanguage !== undefined) url_ += 'currentLanguage=' + encodeURIComponent('' + currentLanguage) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_UpdateResourcePUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_UpdateResourcePUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_UpdateResourcePUT2(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Delete Resource from Project, Auth: Resource, ActionId: 1
   * @param useCache (optional)
   * @return Success
   */
  resource_DeleteResourceDELETE2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_DeleteResourceDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_DeleteResourceDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_DeleteResourceDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Share Resource with user, Auth: Resource, ActionId: Read
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_ShareResourceGET(
    resourceId: number,
    projectId: number,
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/share/user/{userId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_ShareResourceGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_ShareResourceGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_ShareResourceGET(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Share Resource with user, Auth: Resource, ActionId: Read
   * @param useCache (optional)
   * @return Success
   */
  resource_ShareResourceGET2(
    resourceId: number,
    projectId: number,
    userId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/share/user/{userId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_ShareResourceGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_ShareResourceGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_ShareResourceGET2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param api_version (optional)
   * @param file (optional)
   * @return Success
   */
  resource_UploadFilePOST(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    file?: FileParameter | undefined
  ): Observable<string> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/upload?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_UploadFilePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_UploadFilePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processResource_UploadFilePOST(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_RemoveFileDELETE(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/upload?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_RemoveFileDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_RemoveFileDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_RemoveFileDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param file (optional)
   * @return Success
   */
  resource_UploadFilePOST2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    file?: FileParameter | undefined
  ): Observable<string> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/upload?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_UploadFilePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_UploadFilePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processResource_UploadFilePOST2(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @return Success
   */
  resource_RemoveFileDELETE2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/upload?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_RemoveFileDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_RemoveFileDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_RemoveFileDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_RemoveFileDELETE3(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/file/remove?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_RemoveFileDELETE3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_RemoveFileDELETE3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_RemoveFileDELETE3(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @return Success
   */
  resource_RemoveFileDELETE4(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/file/remove?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_RemoveFileDELETE4(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_RemoveFileDELETE4(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_RemoveFileDELETE4(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_GetResourceFullGET(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/full?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_GetResourceFullGET(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * Get Resource by resourceId with ColumnGroupSchemes, Auth: Resource, ActionId: 0
   * @param useCache (optional)
   * @return Success
   */
  resource_GetResourceFullGET2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceFull> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/full?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFullGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFullGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceFull>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceFull>;
        })
      );
  }

  protected processResource_GetResourceFullGET2(response: HttpResponseBase): Observable<ResourceFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceFull>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param filterGroupId (optional)
   * @param parentId (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFilterPOST(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    filterGroupId?: number[] | undefined,
    parentId?: number | undefined,
    api_version?: string | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/filter?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (filterGroupId === null) throw new Error("The parameter 'filterGroupId' cannot be null.");
    else if (filterGroupId !== undefined)
      filterGroupId &&
        filterGroupId.forEach((item) => {
          url_ += 'filterGroupId=' + encodeURIComponent('' + item) + '&';
        });
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFilterPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFilterPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_BuildResourceFilterPOST(response: HttpResponseBase): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param filterGroupId (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFilterPOST2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    filterGroupId?: number[] | undefined,
    parentId?: number | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/filter?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (filterGroupId === null) throw new Error("The parameter 'filterGroupId' cannot be null.");
    else if (filterGroupId !== undefined)
      filterGroupId &&
        filterGroupId.forEach((item) => {
          url_ += 'filterGroupId=' + encodeURIComponent('' + item) + '&';
        });
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFilterPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFilterPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_BuildResourceFilterPOST2(response: HttpResponseBase): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param filterGroupId (optional)
   * @param parentId (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFilterPOST3(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    filterGroupId?: number[] | undefined,
    parentId?: number | undefined,
    api_version?: string | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/filtergroup?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (filterGroupId === null) throw new Error("The parameter 'filterGroupId' cannot be null.");
    else if (filterGroupId !== undefined)
      filterGroupId &&
        filterGroupId.forEach((item) => {
          url_ += 'filterGroupId=' + encodeURIComponent('' + item) + '&';
        });
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFilterPOST3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFilterPOST3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_BuildResourceFilterPOST3(response: HttpResponseBase): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param filterGroupId (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFilterPOST4(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    filterGroupId?: number[] | undefined,
    parentId?: number | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/filtergroup?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (filterGroupId === null) throw new Error("The parameter 'filterGroupId' cannot be null.");
    else if (filterGroupId !== undefined)
      filterGroupId &&
        filterGroupId.forEach((item) => {
          url_ += 'filterGroupId=' + encodeURIComponent('' + item) + '&';
        });
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFilterPOST4(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFilterPOST4(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_BuildResourceFilterPOST4(response: HttpResponseBase): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_GetResourceFilterDefaultValuesPOST(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/filtergroup/defaultvalue?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFilterDefaultValuesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFilterDefaultValuesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_GetResourceFilterDefaultValuesPOST(
    response: HttpResponseBase
  ): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   * @deprecated
   */
  resource_GetResourceFilterDefaultValuesGET(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/filtergroup/defaultvalue?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFilterDefaultValuesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFilterDefaultValuesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_GetResourceFilterDefaultValuesGET(
    response: HttpResponseBase
  ): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  resource_GetResourceFilterDefaultValuesPOST2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/filtergroup/defaultvalue?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFilterDefaultValuesPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFilterDefaultValuesPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_GetResourceFilterDefaultValuesPOST2(
    response: HttpResponseBase
  ): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   * @deprecated
   */
  resource_GetResourceFilterDefaultValuesGET2(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<FilterGroupDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/filtergroup/defaultvalue?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_GetResourceFilterDefaultValuesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_GetResourceFilterDefaultValuesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO[]>;
        })
      );
  }

  protected processResource_GetResourceFilterDefaultValuesGET2(
    response: HttpResponseBase
  ): Observable<FilterGroupDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO[]>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param parentId (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFiltergroupByIdPOST(
    resourceId: number,
    projectId: number,
    filterGroupId: number,
    useCache?: boolean | undefined,
    parentId?: number | undefined,
    api_version?: string | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/filtergroup/{filterGroupId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (filterGroupId === undefined || filterGroupId === null)
      throw new Error("The parameter 'filterGroupId' must be defined.");
    url_ = url_.replace('{filterGroupId}', encodeURIComponent('' + filterGroupId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFiltergroupByIdPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFiltergroupByIdPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO>;
        })
      );
  }

  protected processResource_BuildResourceFiltergroupByIdPOST(response: HttpResponseBase): Observable<FilterGroupDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param parentId (optional)
   * @param body (optional)
   * @return Success
   */
  resource_BuildResourceFiltergroupByIdPOST2(
    resourceId: number,
    projectId: number,
    filterGroupId: number,
    useCache?: boolean | undefined,
    parentId?: number | undefined,
    body?: FilterDTO[] | undefined
  ): Observable<FilterGroupDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/filtergroup/{filterGroupId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (filterGroupId === undefined || filterGroupId === null)
      throw new Error("The parameter 'filterGroupId' must be defined.");
    url_ = url_.replace('{filterGroupId}', encodeURIComponent('' + filterGroupId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (parentId === null) throw new Error("The parameter 'parentId' cannot be null.");
    else if (parentId !== undefined) url_ += 'parentId=' + encodeURIComponent('' + parentId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_BuildResourceFiltergroupByIdPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_BuildResourceFiltergroupByIdPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FilterGroupDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<FilterGroupDTO>;
        })
      );
  }

  protected processResource_BuildResourceFiltergroupByIdPOST2(response: HttpResponseBase): Observable<FilterGroupDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FilterGroupDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FilterGroupDTO>(null as any);
  }

  /**
   * Attach ResourceChild to ResourceParent Auth: Resource Update
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_AttachResourceChildToResourceParentPOST(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_AttachResourceChildToResourceParentPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_AttachResourceChildToResourceParentPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_AttachResourceChildToResourceParentPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Detach ResourceChild from ResourceParent Auth: Resource Update
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resource_DetachhResourceChildToResourceParentDELETE(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_DetachhResourceChildToResourceParentDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_DetachhResourceChildToResourceParentDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_DetachhResourceChildToResourceParentDELETE(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Attach ResourceChild to ResourceParent Auth: Resource Update
   * @param useCache (optional)
   * @return Success
   */
  resource_AttachResourceChildToResourceParentPOST2(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_AttachResourceChildToResourceParentPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_AttachResourceChildToResourceParentPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_AttachResourceChildToResourceParentPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Detach ResourceChild from ResourceParent Auth: Resource Update
   * @param useCache (optional)
   * @return Success
   */
  resource_DetachhResourceChildToResourceParentDELETE2(
    resourceId: number,
    resourceParentId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resource/{resourceId}/parent/{resourceParentId}?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (resourceParentId === undefined || resourceParentId === null)
      throw new Error("The parameter 'resourceParentId' must be defined.");
    url_ = url_.replace('{resourceParentId}', encodeURIComponent('' + resourceParentId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResource_DetachhResourceChildToResourceParentDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResource_DetachhResourceChildToResourceParentDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processResource_DetachhResourceChildToResourceParentDELETE2(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @return Success
   */
  resourceCache_CheckIfResourceIsCachedGET(resourceId: number, projectId: string): Observable<ResourceBase> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/cache/resources/{resourceId}';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceCache_CheckIfResourceIsCachedGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceCache_CheckIfResourceIsCachedGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceBase>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceBase>;
        })
      );
  }

  protected processResourceCache_CheckIfResourceIsCachedGET(response: HttpResponseBase): Observable<ResourceBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceBase);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceBase>(null as any);
  }

  /**
   * Get All Resources Types, Auth: Project -> will be moved to ResourceTypeController
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resourceType_GetResourceTypeAccessGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceTypeAccess[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resourcetype?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeAccessGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeAccessGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeAccess[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeAccess[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeAccessGET(response: HttpResponseBase): Observable<ResourceTypeAccess[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeAccess[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeAccess[]>(null as any);
  }

  /**
   * Get All Resources Types, Auth: Project -> will be moved to ResourceTypeController
   * @param useCache (optional)
   * @return Success
   */
  resourceType_GetResourceTypeAccessGET2(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceTypeAccess[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resourcetype?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeAccessGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeAccessGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeAccess[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeAccess[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeAccessGET2(
    response: HttpResponseBase
  ): Observable<ResourceTypeAccess[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeAccess[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeAccess[]>(null as any);
  }

  /**
   * Get ResourceTypeDefinition by ResourceTypeId, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resourceType_GetResourceTypeDefinitionGET(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ResourceTypeDefinition[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resourcetype/{resourceTypeId}/definition?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeDefinitionGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeDefinitionGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeDefinition[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeDefinition[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeDefinitionGET(
    response: HttpResponseBase
  ): Observable<ResourceTypeDefinition[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeDefinition[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeDefinition[]>(null as any);
  }

  /**
   * Get ResourceTypeDefinition by ResourceTypeId, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  resourceType_GetResourceTypeDefinitionGET2(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined
  ): Observable<ResourceTypeDefinition[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resourcetype/{resourceTypeId}/definition?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeDefinitionGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeDefinitionGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResourceTypeDefinition[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ResourceTypeDefinition[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeDefinitionGET2(
    response: HttpResponseBase
  ): Observable<ResourceTypeDefinition[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ResourceTypeDefinition[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ResourceTypeDefinition[]>(null as any);
  }

  /**
   * Get ResourceTypeDefinition by ResourceTypeId, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  resourceType_GetResourceTypeActionsGET(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<ActionDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/resourcetype/{resourceTypeId}/actions?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeActionsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeActionsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionDTO[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeActionsGET(response: HttpResponseBase): Observable<ActionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ActionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActionDTO[]>(null as any);
  }

  /**
   * Get ResourceTypeDefinition by ResourceTypeId, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  resourceType_GetResourceTypeActionsGET2(
    projectId: number,
    resourceTypeId: number,
    useCache?: boolean | undefined
  ): Observable<ActionDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resourcetype/{resourceTypeId}/actions?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceTypeId === undefined || resourceTypeId === null)
      throw new Error("The parameter 'resourceTypeId' must be defined.");
    url_ = url_.replace('{resourceTypeId}', encodeURIComponent('' + resourceTypeId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceType_GetResourceTypeActionsGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceType_GetResourceTypeActionsGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionDTO[]>;
        })
      );
  }

  protected processResourceType_GetResourceTypeActionsGET2(response: HttpResponseBase): Observable<ActionDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ActionDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActionDTO[]>(null as any);
  }

  /**
   * Get a specific file for a specific resource from a specific project.
   * @param projectId The id for the project.
   * @param resourceId The id of the resource.
   * @param fileId The id for the file to fetch
   * @param useCache (optional) Get the data from a available cache with `true`, or fetch and renew the cache with `false`.
   * @return Success
   */
  files_GetFileGET(
    projectId: number,
    resourceId: number,
    fileId: string,
    useCache?: boolean | undefined
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/files/{fileId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFiles_GetFileGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFiles_GetFileGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processFiles_GetFileGET(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(null as any);
  }

  /**
   * @return No Content
   */
  files_DeleteAllFilesDELETE(projectId: number, resourceId: number, fileId: string): Observable<FileResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/files/{fileId}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFiles_DeleteAllFilesDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFiles_DeleteAllFilesDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processFiles_DeleteAllFilesDELETE(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result204: any = null;
          result204 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FileResponse);
          return _observableOf(result204);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  files_GetAllFilesGET(
    projectId: number,
    resourceId: number,
    useCache?: boolean | undefined
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/files?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFiles_GetAllFilesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFiles_GetAllFilesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processFiles_GetAllFilesGET(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(null as any);
  }

  /**
   * @return No Content
   */
  files_DeleteAllFilesDELETE2(projectId: number, resourceId: number): Observable<FileResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/files';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFiles_DeleteAllFilesDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFiles_DeleteAllFilesDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processFiles_DeleteAllFilesDELETE2(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result204: any = null;
          result204 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FileResponse);
          return _observableOf(result204);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          result500 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PulseProblemDetails);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(null as any);
  }

  /**
   * Get All Roles for Project, Auth: AdminPrivilege, RoleAdmin, UserAdminLight
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  role_GetRolesGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<RoleDTO[]> {
    let url_ = this.baseUrl + '/project/{projectId}/role?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRolesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRolesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO[]>;
        })
      );
  }

  protected processRole_GetRolesGET(response: HttpResponseBase): Observable<RoleDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO[]>(null as any);
  }

  /**
   * Add Role to Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  role_AddRolePOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: RoleDTO | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/role?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_AddRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_AddRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_AddRolePOST(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Get All Roles for Project, Auth: AdminPrivilege, RoleAdmin, UserAdminLight
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @return Success
   */
  role_GetRolesGET2(projectId: number, useCache?: boolean | undefined): Observable<RoleDTO[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRolesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRolesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO[]>;
        })
      );
  }

  protected processRole_GetRolesGET2(response: HttpResponseBase): Observable<RoleDTO[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO[]>(null as any);
  }

  /**
   * Add Role to Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  role_AddRolePOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: RoleDTO | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_AddRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_AddRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_AddRolePOST2(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Get Role, Auth: AdminPrivilege, RoleAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  role_GetRoleGET(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_GetRoleGET(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Update Role, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  role_UpdateRolePUT(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: RoleDTO | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_UpdateRolePUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_UpdateRolePUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_UpdateRolePUT(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Delete Role from Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  role_DeleteRoleDELETE(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_DeleteRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_DeleteRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_DeleteRoleDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get Role, Auth: AdminPrivilege, RoleAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @return Success
   */
  role_GetRoleGET2(roleId: number, projectId: number, useCache?: boolean | undefined): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRoleGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRoleGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_GetRoleGET2(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Update Role, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  role_UpdateRolePUT2(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    body?: RoleDTO | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_UpdateRolePUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_UpdateRolePUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processRole_UpdateRolePUT2(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Delete Role from Project, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  role_DeleteRoleDELETE2(roleId: number, projectId: number, useCache?: boolean | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_DeleteRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_DeleteRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_DeleteRoleDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get all users for specified role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param pageNumber (optional) Page number
   * @param pageSize (optional) Page size
   * @param sortOrderColumn (optional) Sort order column
   * @param sortOderAscending (optional) Sort order ascending
   * @param searchString (optional) Search string
   * @param useCache (optional) Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  role_GetUsersForRoleGET(
    roleId: number,
    projectId: number,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<PageInfo_1OfUserBase> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/users?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOderAscending === null) throw new Error("The parameter 'sortOderAscending' cannot be null.");
    else if (sortOderAscending !== undefined)
      url_ += 'sortOderAscending=' + encodeURIComponent('' + sortOderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetUsersForRoleGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetUsersForRoleGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageInfo_1OfUserBase>;
            }
          } else return _observableThrow(response_) as any as Observable<PageInfo_1OfUserBase>;
        })
      );
  }

  protected processRole_GetUsersForRoleGET(response: HttpResponseBase): Observable<PageInfo_1OfUserBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PageInfo_1OfUserBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PageInfo_1OfUserBase>(null as any);
  }

  /**
   * Get all users for specified role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param pageNumber (optional) Page number
   * @param pageSize (optional) Page size
   * @param sortOrderColumn (optional) Sort order column
   * @param sortOderAscending (optional) Sort order ascending
   * @param searchString (optional) Search string
   * @param useCache (optional) Whether to use caching
   * @return Success
   */
  role_GetUsersForRoleGET2(
    roleId: number,
    projectId: number,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: UserColumnEnum | undefined,
    sortOderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<PageInfo_1OfUserBase> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/users?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOderAscending === null) throw new Error("The parameter 'sortOderAscending' cannot be null.");
    else if (sortOderAscending !== undefined)
      url_ += 'sortOderAscending=' + encodeURIComponent('' + sortOderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetUsersForRoleGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetUsersForRoleGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageInfo_1OfUserBase>;
            }
          } else return _observableThrow(response_) as any as Observable<PageInfo_1OfUserBase>;
        })
      );
  }

  protected processRole_GetUsersForRoleGET2(response: HttpResponseBase): Observable<PageInfo_1OfUserBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PageInfo_1OfUserBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PageInfo_1OfUserBase>(null as any);
  }

  /**
   * Add Role to AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  role_AddRoleToAccessPolicyPOST(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/accesspolicy/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_AddRoleToAccessPolicyPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_AddRoleToAccessPolicyPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_AddRoleToAccessPolicyPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Delete Role from AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  role_DeleteRoleToAccessPolicyDELETE(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/accesspolicy/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_DeleteRoleToAccessPolicyDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_DeleteRoleToAccessPolicyDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_DeleteRoleToAccessPolicyDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Role to AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  role_AddRoleToAccessPolicyPOST2(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/accesspolicy/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_AddRoleToAccessPolicyPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_AddRoleToAccessPolicyPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_AddRoleToAccessPolicyPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Delete Role from AccessPolicy, Auth: AdminPrivilege, RoleAdmin
   * @param useCache (optional)
   * @return Success
   */
  role_DeleteRoleToAccessPolicyDELETE2(
    roleId: number,
    accessPolicyId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/accesspolicy/{accessPolicyId}?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (accessPolicyId === undefined || accessPolicyId === null)
      throw new Error("The parameter 'accessPolicyId' must be defined.");
    url_ = url_.replace('{accessPolicyId}', encodeURIComponent('' + accessPolicyId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_DeleteRoleToAccessPolicyDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_DeleteRoleToAccessPolicyDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processRole_DeleteRoleToAccessPolicyDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves role full, Auth: AdminPrivilege : RoleAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  role_GetRoleFullGET(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<RoleFull> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/full?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRoleFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRoleFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleFull>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleFull>;
        })
      );
  }

  protected processRole_GetRoleFullGET(response: HttpResponseBase): Observable<RoleFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleFull>(null as any);
  }

  /**
   * Retrieves role full, Auth: AdminPrivilege : RoleAdmin, UserAdminLight
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) >Whether to use caching
   * @return Success
   */
  role_GetRoleFullGET2(roleId: number, projectId: number, useCache?: boolean | undefined): Observable<RoleFull> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/full?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_GetRoleFullGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_GetRoleFullGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleFull>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleFull>;
        })
      );
  }

  protected processRole_GetRoleFullGET2(response: HttpResponseBase): Observable<RoleFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleFull>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  roleGeneralAccess_SetGeneralAccessPOST(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: GeneralAccessFor | undefined
  ): Observable<UpdateGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/generalaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleGeneralAccess_SetGeneralAccessPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleGeneralAccess_SetGeneralAccessPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateGeneralAccessResponse>;
        })
      );
  }

  protected processRoleGeneralAccess_SetGeneralAccessPOST(
    response: HttpResponseBase
  ): Observable<UpdateGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateGeneralAccessResponse>(null as any);
  }

  /**
   * @param resourceTypeId (optional)
   * @param useCache (optional)
   * @return Success
   */
  roleGeneralAccess_DeleteGeneralAccessDELETE(
    projectId: number,
    roleId: number,
    resourceTypeId?: number | undefined,
    useCache?: boolean | undefined
  ): Observable<DeleteGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/generalaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (resourceTypeId === null) throw new Error("The parameter 'resourceTypeId' cannot be null.");
    else if (resourceTypeId !== undefined) url_ += 'resourceTypeId=' + encodeURIComponent('' + resourceTypeId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleGeneralAccess_DeleteGeneralAccessDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleGeneralAccess_DeleteGeneralAccessDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteGeneralAccessResponse>;
        })
      );
  }

  protected processRoleGeneralAccess_DeleteGeneralAccessDELETE(
    response: HttpResponseBase
  ): Observable<DeleteGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteGeneralAccessResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  roleResourceAccess_SetGeneralAccessPOST(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessFor | undefined
  ): Observable<UpdateGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/resource-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleResourceAccess_SetGeneralAccessPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleResourceAccess_SetGeneralAccessPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateGeneralAccessResponse>;
        })
      );
  }

  protected processRoleResourceAccess_SetGeneralAccessPOST(
    response: HttpResponseBase
  ): Observable<UpdateGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateGeneralAccessResponse>(null as any);
  }

  /**
   * @param resourceId (optional)
   * @param useCache (optional)
   * @return Success
   */
  roleResourceAccess_DeleteGeneralAccessDELETE(
    projectId: number,
    roleId: number,
    resourceId?: number | undefined,
    useCache?: boolean | undefined
  ): Observable<DeleteGeneralAccessResponse> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/resource-access?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (resourceId === null) throw new Error("The parameter 'resourceId' cannot be null.");
    else if (resourceId !== undefined) url_ += 'resourceId=' + encodeURIComponent('' + resourceId) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoleResourceAccess_DeleteGeneralAccessDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoleResourceAccess_DeleteGeneralAccessDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteGeneralAccessResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteGeneralAccessResponse>;
        })
      );
  }

  protected processRoleResourceAccess_DeleteGeneralAccessDELETE(
    response: HttpResponseBase
  ): Observable<DeleteGeneralAccessResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteGeneralAccessResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteGeneralAccessResponse>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  signature_GetPulseSignatureGET(useCache?: boolean | undefined, api_version?: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/signature?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSignature_GetPulseSignatureGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSignature_GetPulseSignatureGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSignature_GetPulseSignatureGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @return Success
   */
  signature_GetPulseSignatureGET2(useCache?: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/signature?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSignature_GetPulseSignatureGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSignature_GetPulseSignatureGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSignature_GetPulseSignatureGET2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  team_BuildTeamPOST(useCache?: boolean | undefined, body?: TeamRequestData | undefined): Observable<TeamResponse> {
    let url_ = this.baseUrl + '/v1/teams/create-team?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTeam_BuildTeamPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTeam_BuildTeamPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamResponse>;
        })
      );
  }

  protected processTeam_BuildTeamPOST(response: HttpResponseBase): Observable<TeamResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TeamResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<TeamResponse>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @return Success
   */
  token_GetPulseTokenGET(useCache?: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/token?';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processToken_GetPulseTokenGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processToken_GetPulseTokenGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processToken_GetPulseTokenGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @return Success
   */
  token_GetPulseTokenByUserGET(userId: number, useCache?: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/user/{userId}/token?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processToken_GetPulseTokenByUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processToken_GetPulseTokenByUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processToken_GetPulseTokenByUserGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @return Success
   */
  token_BuildTokenForProjectAndUserGET(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/token?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processToken_BuildTokenForProjectAndUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processToken_BuildTokenForProjectAndUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processToken_BuildTokenForProjectAndUserGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Replaces signature withing header with Pulse formatted signature
   * @param useCache (optional)
   * @return Success
   */
  token_BuildTokenForProjectAndDelegationGET(
    resourceId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/delegation/{resourceId}/token?';
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processToken_BuildTokenForProjectAndDelegationGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processToken_BuildTokenForProjectAndDelegationGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processToken_BuildTokenForProjectAndDelegationGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  translationsExportToFile_ExportToFilePOST(
    projectId: number,
    resourceId: number,
    body?: ExportTranslationsRequest | undefined
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations/export-to-file';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsExportToFile_ExportToFilePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsExportToFile_ExportToFilePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processTranslationsExportToFile_ExportToFilePOST(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(null as any);
  }

  /**
   * @param file (optional)
   * @return Success
   */
  translationsImportFromFile_ImportModuleTranslationsFromFilePOST(
    projectId: number,
    resourceId: number,
    file?: FileParameter | undefined
  ): Observable<ImportTranslationsResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations/import-to-file';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsImportFromFile_ImportModuleTranslationsFromFilePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsImportFromFile_ImportModuleTranslationsFromFilePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImportTranslationsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ImportTranslationsResponse>;
        })
      );
  }

  protected processTranslationsImportFromFile_ImportModuleTranslationsFromFilePOST(
    response: HttpResponseBase
  ): Observable<ImportTranslationsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ImportTranslationsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ImportTranslationsResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  projectLanguage_AddNewLanguagePOST(
    projectId: number,
    body?: AddProjectLanguageRequest | undefined
  ): Observable<AddProjectLanguageResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectLanguage_AddNewLanguagePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectLanguage_AddNewLanguagePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddProjectLanguageResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddProjectLanguageResponse>;
        })
      );
  }

  protected processProjectLanguage_AddNewLanguagePOST(
    response: HttpResponseBase
  ): Observable<AddProjectLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddProjectLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddProjectLanguageResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectLanguage_GetAllProjectLanguagesGET(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<GetAllProjectLanguageResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectLanguage_GetAllProjectLanguagesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectLanguage_GetAllProjectLanguagesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllProjectLanguageResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllProjectLanguageResponse>;
        })
      );
  }

  protected processProjectLanguage_GetAllProjectLanguagesGET(
    response: HttpResponseBase
  ): Observable<GetAllProjectLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllProjectLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllProjectLanguageResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  projectLanguage_UpdateProjectLanguagePUT(
    projectId: number,
    body?: UpdateProjectLanguageRequest | undefined
  ): Observable<UpdateProjectLanguageResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectLanguage_UpdateProjectLanguagePUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectLanguage_UpdateProjectLanguagePUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateProjectLanguageResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateProjectLanguageResponse>;
        })
      );
  }

  protected processProjectLanguage_UpdateProjectLanguagePUT(
    response: HttpResponseBase
  ): Observable<UpdateProjectLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateProjectLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UpdateProjectLanguageResponse>(null as any);
  }

  /**
   * @return Success
   */
  projectLanguage_DeleteProjectLanguageDELETE(
    projectId: number,
    language: string
  ): Observable<DeleteProjectLanguageResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages/{language}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (language === undefined || language === null) throw new Error("The parameter 'language' must be defined.");
    url_ = url_.replace('{language}', encodeURIComponent('' + language));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectLanguage_DeleteProjectLanguageDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectLanguage_DeleteProjectLanguageDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteProjectLanguageResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteProjectLanguageResponse>;
        })
      );
  }

  protected processProjectLanguage_DeleteProjectLanguageDELETE(
    response: HttpResponseBase
  ): Observable<DeleteProjectLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteProjectLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteProjectLanguageResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  projectTranslations_CreateOrUpdateProjectTranslationsPOST(
    projectId: number,
    language: string,
    body?: AddOrUpdateProjectTranslationRequest | undefined
  ): Observable<AddOrUpdateProjectTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages/{language}/translations';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (language === undefined || language === null) throw new Error("The parameter 'language' must be defined.");
    url_ = url_.replace('{language}', encodeURIComponent('' + language));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectTranslations_CreateOrUpdateProjectTranslationsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectTranslations_CreateOrUpdateProjectTranslationsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddOrUpdateProjectTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddOrUpdateProjectTranslationResponse>;
        })
      );
  }

  protected processProjectTranslations_CreateOrUpdateProjectTranslationsPOST(
    response: HttpResponseBase
  ): Observable<AddOrUpdateProjectTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddOrUpdateProjectTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddOrUpdateProjectTranslationResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectTranslations_GetProjectTranslationsGET(
    projectId: number,
    language: string,
    useCache?: boolean | undefined
  ): Observable<GetAllProjectTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages/{language}/translations?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (language === undefined || language === null) throw new Error("The parameter 'language' must be defined.");
    url_ = url_.replace('{language}', encodeURIComponent('' + language));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectTranslations_GetProjectTranslationsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectTranslations_GetProjectTranslationsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllProjectTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllProjectTranslationResponse>;
        })
      );
  }

  protected processProjectTranslations_GetProjectTranslationsGET(
    response: HttpResponseBase
  ): Observable<GetAllProjectTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllProjectTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllProjectTranslationResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  projectTranslations_GetProjectTranslationsBackupGET(
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<GetAllProjectTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/languages/backup/translations?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProjectTranslations_GetProjectTranslationsBackupGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProjectTranslations_GetProjectTranslationsBackupGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllProjectTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllProjectTranslationResponse>;
        })
      );
  }

  protected processProjectTranslations_GetProjectTranslationsBackupGET(
    response: HttpResponseBase
  ): Observable<GetAllProjectTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllProjectTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllProjectTranslationResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resourceTranslations_CreateOrUpdateResourceTranslationsPOST(
    projectId: number,
    resourceId: number,
    language: string,
    body?: AddOrUpdateResourceTranslationRequest | undefined
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/languages/{language}/translations';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (language === undefined || language === null) throw new Error("The parameter 'language' must be defined.");
    url_ = url_.replace('{language}', encodeURIComponent('' + language));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_CreateOrUpdateResourceTranslationsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_CreateOrUpdateResourceTranslationsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddOrUpdateResourceTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddOrUpdateResourceTranslationResponse>;
        })
      );
  }

  protected processResourceTranslations_CreateOrUpdateResourceTranslationsPOST(
    response: HttpResponseBase
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddOrUpdateResourceTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddOrUpdateResourceTranslationResponse>(null as any);
  }

  /**
   * @return Success
   */
  resourceTranslations_DeleteTranslationDELETE(
    projectId: number,
    resourceId: number
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_DeleteTranslationDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_DeleteTranslationDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddOrUpdateResourceTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddOrUpdateResourceTranslationResponse>;
        })
      );
  }

  protected processResourceTranslations_DeleteTranslationDELETE(
    response: HttpResponseBase
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddOrUpdateResourceTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddOrUpdateResourceTranslationResponse>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  resourceTranslations_GetResourceTranslationsByKeyGET(
    projectId: number,
    resourceId: number,
    translationKey: string,
    useCache?: boolean | undefined
  ): Observable<GetAllResourceTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations/{translationKey}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (translationKey === undefined || translationKey === null)
      throw new Error("The parameter 'translationKey' must be defined.");
    url_ = url_.replace('{translationKey}', encodeURIComponent('' + translationKey));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_GetResourceTranslationsByKeyGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_GetResourceTranslationsByKeyGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetAllResourceTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetAllResourceTranslationResponse>;
        })
      );
  }

  protected processResourceTranslations_GetResourceTranslationsByKeyGET(
    response: HttpResponseBase
  ): Observable<GetAllResourceTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllResourceTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetAllResourceTranslationResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resourceTranslations_CreateOrUpdateResourceTranslationsByKeyPOST(
    projectId: number,
    resourceId: number,
    translationKey: string,
    body?: AddOrUpdateResourceTranslationByKeyRequest | undefined
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations/{translationKey}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (translationKey === undefined || translationKey === null)
      throw new Error("The parameter 'translationKey' must be defined.");
    url_ = url_.replace('{translationKey}', encodeURIComponent('' + translationKey));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResourceTranslations_CreateOrUpdateResourceTranslationsByKeyPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResourceTranslations_CreateOrUpdateResourceTranslationsByKeyPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddOrUpdateResourceTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddOrUpdateResourceTranslationResponse>;
        })
      );
  }

  protected processResourceTranslations_CreateOrUpdateResourceTranslationsByKeyPOST(
    response: HttpResponseBase
  ): Observable<AddOrUpdateResourceTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddOrUpdateResourceTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddOrUpdateResourceTranslationResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  translationsModule_CreateOrUpdateTranslationsPOST(
    projectId: number,
    resourceId: number,
    body?: AddOrUpdateTranslationsRequest | undefined
  ): Observable<AddOrUpdateTranslationResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/translation-modules/{resourceId}/translations';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsModule_CreateOrUpdateTranslationsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsModule_CreateOrUpdateTranslationsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AddOrUpdateTranslationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AddOrUpdateTranslationResponse>;
        })
      );
  }

  protected processTranslationsModule_CreateOrUpdateTranslationsPOST(
    response: HttpResponseBase
  ): Observable<AddOrUpdateTranslationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddOrUpdateTranslationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<AddOrUpdateTranslationResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  translationsModule_DeleteTranslationsDELETE(
    projectId: number,
    resourceId: number,
    body?: DeleteAllLanguagesTranslationsRequest | undefined
  ): Observable<DeleteTranslationsResponse> {
    let url_ = this.baseUrl + '/v1/projects/{projectId}/translation-modules/{resourceId}/translations';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsModule_DeleteTranslationsDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsModule_DeleteTranslationsDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteTranslationsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteTranslationsResponse>;
        })
      );
  }

  protected processTranslationsModule_DeleteTranslationsDELETE(
    response: HttpResponseBase
  ): Observable<DeleteTranslationsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteTranslationsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteTranslationsResponse>(null as any);
  }

  /**
   * @return Success
   */
  translationsModule_GetJoinTranslationGET(
    projectId: number,
    resourceId: number,
    sourceLanguage: string,
    targetLanguage: string
  ): Observable<GetJoinedTranslationsResponse> {
    let url_ =
      this.baseUrl +
      '/v1/projects/{projectId}/translation-modules/{resourceId}/languages/{sourceLanguage}/translations/join/{targetLanguage}';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (sourceLanguage === undefined || sourceLanguage === null)
      throw new Error("The parameter 'sourceLanguage' must be defined.");
    url_ = url_.replace('{sourceLanguage}', encodeURIComponent('' + sourceLanguage));
    if (targetLanguage === undefined || targetLanguage === null)
      throw new Error("The parameter 'targetLanguage' must be defined.");
    url_ = url_.replace('{targetLanguage}', encodeURIComponent('' + targetLanguage));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsModule_GetJoinTranslationGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsModule_GetJoinTranslationGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetJoinedTranslationsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GetJoinedTranslationsResponse>;
        })
      );
  }

  protected processTranslationsModule_GetJoinTranslationGET(
    response: HttpResponseBase
  ): Observable<GetJoinedTranslationsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetJoinedTranslationsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserErrorResponse);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<GetJoinedTranslationsResponse>(null as any);
  }

  /**
   * @return Success
   */
  translationsModuleUtility_GetFileTypesGET(projectId: string, resourceId: string): Observable<string[]> {
    let url_ =
      this.baseUrl + '/v1/projects/{projectId}/resources/{resourceId}/translations/utility/supported-file-types';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTranslationsModuleUtility_GetFileTypesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTranslationsModuleUtility_GetFileTypesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processTranslationsModuleUtility_GetFileTypesGET(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
     * Ability to add a new User to the system
    Auth: UserAdmin
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
  user_AddUserPOST(projectId: number, api_version?: string | undefined, body?: UserBase | undefined): Observable<void> {
    let url_ = this.baseUrl + '/project/{projectId}/user/add?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUser_AddUserPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Ability to add a new User to the system
    Auth: UserAdmin
     * @param body (optional) 
     * @return Success
     */
  user_AddUserPOST2(projectId: number, body?: UserBase | undefined): Observable<void> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/add';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUser_AddUserPOST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Search for users on global level, should also work for non admin user that wants to make a delegation to another user
    TODO: How can we improve security that not everybody of a project can search in the whole user database?
    Auth: Project
     * @param useCache (optional) 
     * @param api_version (optional) 
     * @return Success
     */
  user_SearchUsersGET(
    searchString: string,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/project/{projectId}/user/search/{searchString}?';
    if (searchString === undefined || searchString === null)
      throw new Error("The parameter 'searchString' must be defined.");
    url_ = url_.replace('{searchString}', encodeURIComponent('' + searchString));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_SearchUsersGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_SearchUsersGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_SearchUsersGET(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
     * Search for users on global level, should also work for non admin user that wants to make a delegation to another user
    TODO: How can we improve security that not everybody of a project can search in the whole user database?
    Auth: Project
     * @param useCache (optional) 
     * @return Success
     */
  user_SearchUsersGET2(
    searchString: string,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/search/{searchString}?';
    if (searchString === undefined || searchString === null)
      throw new Error("The parameter 'searchString' must be defined.");
    url_ = url_.replace('{searchString}', encodeURIComponent('' + searchString));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_SearchUsersGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_SearchUsersGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_SearchUsersGET2(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Search for users, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_SearchProjectUsersGET(
    projectId: number,
    searchString: string,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/project/{projectId}/user/project/search/{searchString}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (searchString === undefined || searchString === null)
      throw new Error("The parameter 'searchString' must be defined.");
    url_ = url_.replace('{searchString}', encodeURIComponent('' + searchString));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_SearchProjectUsersGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_SearchProjectUsersGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_SearchProjectUsersGET(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Search for users, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  user_SearchProjectUsersGET2(
    projectId: number,
    searchString: string,
    useCache?: boolean | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/project/search/{searchString}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (searchString === undefined || searchString === null)
      throw new Error("The parameter 'searchString' must be defined.");
    url_ = url_.replace('{searchString}', encodeURIComponent('' + searchString));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_SearchProjectUsersGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_SearchProjectUsersGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_SearchProjectUsersGET2(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Search for users by user list, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_GetUserByIdsPOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: number[] | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/project/{projectId}/user/list?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserByIdsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserByIdsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_GetUserByIdsPOST(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Search for users by user list, Auth: Project
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_GetUserByIdsPOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: number[] | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/list?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserByIdsPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserByIdsPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_GetUserByIdsPOST2(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Retrieves user profile, Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_GetUserProfileGET(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserProfile> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserProfileGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserProfileGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserProfile>;
            }
          } else return _observableThrow(response_) as any as Observable<UserProfile>;
        })
      );
  }

  protected processUser_GetUserProfileGET(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserProfile);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(null as any);
  }

  /**
   * Remove user from Project, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_DeleteUserFromProjectDELETE(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserFromProjectDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserFromProjectDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserFromProjectDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves user profile, Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserProfileGET2(userId: number, projectId: number, useCache?: boolean | undefined): Observable<UserProfile> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserProfileGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserProfileGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserProfile>;
            }
          } else return _observableThrow(response_) as any as Observable<UserProfile>;
        })
      );
  }

  protected processUser_GetUserProfileGET2(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserProfile);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(null as any);
  }

  /**
   * Remove user from Project, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  user_DeleteUserFromProjectDELETE2(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserFromProjectDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserFromProjectDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserFromProjectDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves all users for Project,  Auth: Project
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_GetUsersGET(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/project/{projectId}/user?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUsersGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUsersGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_GetUsersGET(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Add User to Project,  Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToProjectPOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: number | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToProjectPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToProjectPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToProjectPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves all users for Project,  Auth: Project
   * @param useCache (optional)
   * @return Success
   */
  user_GetUsersGET2(projectId: number, useCache?: boolean | undefined): Observable<UserBase[]> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUsersGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUsersGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase[]>;
        })
      );
  }

  protected processUser_GetUsersGET2(response: HttpResponseBase): Observable<UserBase[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase[]>(null as any);
  }

  /**
   * Add User to Project,  Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToProjectPOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: number | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToProjectPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToProjectPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToProjectPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Users to Project,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToProjectBulkPOST(
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: string[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/users/bulk?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToProjectBulkPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToProjectBulkPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToProjectBulkPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Users to Project,  Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToProjectBulkPOST2(
    projectId: number,
    useCache?: boolean | undefined,
    body?: string[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/users/bulk?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToProjectBulkPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToProjectBulkPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToProjectBulkPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add User to Role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) Whether to user caching
   * @param api_version (optional)
   * @return Success
   */
  user_AddUserToRolePOST(
    userId: number,
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/role/{roleId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToRolePOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove user from Role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_DeleteUserFromRoleDELETE(
    userId: number,
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/role/{roleId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserFromRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserFromRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserFromRoleDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add User to Role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional) Whether to user caching
   * @return Success
   */
  user_AddUserToRolePOST2(
    userId: number,
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/role/{roleId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToRolePOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove user from Role, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param roleId Role ID
   * @param projectId Project ID
   * @param useCache (optional)
   * @return Success
   */
  user_DeleteUserFromRoleDELETE2(
    userId: number,
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/role/{roleId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserFromRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserFromRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserFromRoleDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Users to Role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToRoleBulkPOST(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: string[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/users/bulk/by-user-externalids?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToRoleBulkPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToRoleBulkPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToRoleBulkPOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Add Users to Role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddUserToRoleBulkPOST2(
    roleId: number,
    projectId: number,
    useCache?: boolean | undefined,
    body?: string[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/users/bulk/by-user-externalids?';
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddUserToRoleBulkPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddUserToRoleBulkPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddUserToRoleBulkPOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Get all Roles for specified user, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param projectId Project ID
   * @param pageNumber (optional) Page number
   * @param pageSize (optional) Page size
   * @param sortOrderColumn (optional) Sort order column
   * @param sortOrderAscending (optional) Sort order ascending
   * @param searchString (optional) Search string
   * @param useCache (optional) Whether to use caching
   * @param api_version (optional)
   * @return Success
   */
  user_GetRolesForUserGET(
    userId: number,
    projectId: number,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: RoleColumnEnum | undefined,
    sortOrderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<PageInfo_1OfRoleDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/roles?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOrderAscending === null) throw new Error("The parameter 'sortOrderAscending' cannot be null.");
    else if (sortOrderAscending !== undefined)
      url_ += 'sortOrderAscending=' + encodeURIComponent('' + sortOrderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetRolesForUserGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetRolesForUserGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageInfo_1OfRoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<PageInfo_1OfRoleDTO>;
        })
      );
  }

  protected processUser_GetRolesForUserGET(response: HttpResponseBase): Observable<PageInfo_1OfRoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PageInfo_1OfRoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PageInfo_1OfRoleDTO>(null as any);
  }

  /**
   * Get all Roles for specified user, Auth: AdminPrivilege, UserAdmin, UserAdminLight
   * @param userId User ID
   * @param projectId Project ID
   * @param pageNumber (optional) Page number
   * @param pageSize (optional) Page size
   * @param sortOrderColumn (optional) Sort order column
   * @param sortOrderAscending (optional) Sort order ascending
   * @param searchString (optional) Search string
   * @param useCache (optional) Whether to use caching
   * @return Success
   */
  user_GetRolesForUserGET2(
    userId: number,
    projectId: number,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    sortOrderColumn?: RoleColumnEnum | undefined,
    sortOrderAscending?: boolean | undefined,
    searchString?: string | undefined,
    useCache?: boolean | undefined
  ): Observable<PageInfo_1OfRoleDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/roles?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (sortOrderColumn === null) throw new Error("The parameter 'sortOrderColumn' cannot be null.");
    else if (sortOrderColumn !== undefined) url_ += 'sortOrderColumn=' + encodeURIComponent('' + sortOrderColumn) + '&';
    if (sortOrderAscending === null) throw new Error("The parameter 'sortOrderAscending' cannot be null.");
    else if (sortOrderAscending !== undefined)
      url_ += 'sortOrderAscending=' + encodeURIComponent('' + sortOrderAscending) + '&';
    if (searchString === null) throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined) url_ += 'searchString=' + encodeURIComponent('' + searchString) + '&';
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetRolesForUserGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetRolesForUserGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageInfo_1OfRoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<PageInfo_1OfRoleDTO>;
        })
      );
  }

  protected processUser_GetRolesForUserGET2(response: HttpResponseBase): Observable<PageInfo_1OfRoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PageInfo_1OfRoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PageInfo_1OfRoleDTO>(null as any);
  }

  /**
   * Remove/De-Activate user from pulse, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_DeleteUserDELETE(
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove/De-Activate user from pulse, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @return Success
   */
  user_DeleteUserDELETE2(userId: number, useCache?: boolean | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/user/{userId}?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_DeleteUserDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_DeleteUserDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_DeleteUserDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Retrieves user full, Auth: AdminPrivilege : User Admin, User Admin Light
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_GetUserFullGET(
    userId: number,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserFull> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/full?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserFullGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserFullGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserFull>;
            }
          } else return _observableThrow(response_) as any as Observable<UserFull>;
        })
      );
  }

  protected processUser_GetUserFullGET(response: HttpResponseBase): Observable<UserFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserFull>(null as any);
  }

  /**
   * Retrieves user full, Auth: AdminPrivilege : User Admin, User Admin Light
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserFullGET2(userId: number, projectId: number, useCache?: boolean | undefined): Observable<UserFull> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/full?';
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserFullGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserFullGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserFull>;
            }
          } else return _observableThrow(response_) as any as Observable<UserFull>;
        })
      );
  }

  protected processUser_GetUserFullGET2(response: HttpResponseBase): Observable<UserFull> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserFull);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserFull>(null as any);
  }

  /**
   * Create internal role for User, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddInternalRolePOST(
    projectId: number,
    userId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ActionDTO[] | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/resource/{resourceId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddInternalRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddInternalRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processUser_AddInternalRolePOST(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Create internal role for User, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddInternalRolePOST2(
    projectId: number,
    userId: number,
    resourceId: number,
    useCache?: boolean | undefined,
    body?: ActionDTO[] | undefined
  ): Observable<RoleDTO> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/resource/{resourceId}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddInternalRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddInternalRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleDTO>;
        })
      );
  }

  protected processUser_AddInternalRolePOST2(response: HttpResponseBase): Observable<RoleDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDTO);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<RoleDTO>(null as any);
  }

  /**
   * Grant actions on resources for user to its internal role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddResourceAccessToInternalRolePOST(
    projectId: number,
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddResourceAccessToInternalRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddResourceAccessToInternalRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddResourceAccessToInternalRolePOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove actions on resources for user to its internal role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_RemoveResourceAccessFromInternalRoleDELETE(
    projectId: number,
    userId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/user/{userId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_RemoveResourceAccessFromInternalRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_RemoveResourceAccessFromInternalRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_RemoveResourceAccessFromInternalRoleDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Grant actions on resources for user to its internal role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddResourceAccessToInternalRolePOST2(
    projectId: number,
    userId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddResourceAccessToInternalRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddResourceAccessToInternalRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddResourceAccessToInternalRolePOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove actions on resources for user to its internal role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_RemoveResourceAccessFromInternalRoleDELETE2(
    projectId: number,
    userId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user/{userId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_RemoveResourceAccessFromInternalRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_RemoveResourceAccessFromInternalRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_RemoveResourceAccessFromInternalRoleDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Grant actions for resources to a role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddResourceAccessToRolePOST(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddResourceAccessToRolePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddResourceAccessToRolePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddResourceAccessToRolePOST(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove actions from a role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param api_version (optional)
   * @param body (optional)
   * @return Success
   */
  user_RemoveResourceAccessFromRoleDELETE(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/project/{projectId}/role/{roleId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_RemoveResourceAccessFromRoleDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_RemoveResourceAccessFromRoleDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_RemoveResourceAccessFromRoleDELETE(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Grant actions for resources to a role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_AddResourceAccessToRolePOST2(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_AddResourceAccessToRolePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_AddResourceAccessToRolePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_AddResourceAccessToRolePOST2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Remove actions from a role, Auth: AdminPrivilege, UserAdmin
   * @param useCache (optional)
   * @param body (optional)
   * @return Success
   */
  user_RemoveResourceAccessFromRoleDELETE2(
    projectId: number,
    roleId: number,
    useCache?: boolean | undefined,
    body?: ResourceAccessRequest[] | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/role/{roleId}/resourceaccess?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (roleId === undefined || roleId === null) throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_RemoveResourceAccessFromRoleDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_RemoveResourceAccessFromRoleDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processUser_RemoveResourceAccessFromRoleDELETE2(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * Gets the user by its external user id.
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_GetUserBasePOST(
    externalUserId: string,
    projectId: number,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<UserBase> {
    let url_ = this.baseUrl + '/project/{projectId}/user-by-external-id/{externalUserId}?';
    if (externalUserId === undefined || externalUserId === null)
      throw new Error("The parameter 'externalUserId' must be defined.");
    url_ = url_.replace('{externalUserId}', encodeURIComponent('' + externalUserId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserBasePOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserBasePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase>;
        })
      );
  }

  protected processUser_GetUserBasePOST(response: HttpResponseBase): Observable<UserBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase>(null as any);
  }

  /**
   * Gets the user by its external user id.
   * @param useCache (optional)
   * @return Success
   */
  user_GetUserBasePOST2(
    externalUserId: string,
    projectId: number,
    useCache?: boolean | undefined
  ): Observable<UserBase> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/user-by-external-id/{externalUserId}?';
    if (externalUserId === undefined || externalUserId === null)
      throw new Error("The parameter 'externalUserId' must be defined.");
    url_ = url_.replace('{externalUserId}', encodeURIComponent('' + externalUserId));
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetUserBasePOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetUserBasePOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserBase>;
            }
          } else return _observableThrow(response_) as any as Observable<UserBase>;
        })
      );
  }

  protected processUser_GetUserBasePOST2(response: HttpResponseBase): Observable<UserBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserBase);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserBase>(null as any);
  }

  /**
   * @param useCache (optional)
   * @param api_version (optional)
   * @return Success
   */
  user_GetActionGET(
    projectId: number,
    resourceId: number,
    actionName: string,
    useCache?: boolean | undefined,
    api_version?: string | undefined
  ): Observable<string> {
    let url_ = this.baseUrl + '/project/{projectId}/resources/{resourceId}/actions/{actionName}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (actionName === undefined || actionName === null) throw new Error("The parameter 'actionName' must be defined.");
    url_ = url_.replace('{actionName}', encodeURIComponent('' + actionName));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += 'api-version=' + encodeURIComponent('' + api_version) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetActionGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetActionGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processUser_GetActionGET(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param useCache (optional)
   * @return Success
   */
  user_GetActionGET2(
    projectId: number,
    resourceId: number,
    actionName: string,
    useCache?: boolean | undefined
  ): Observable<string> {
    let url_ = this.baseUrl + '/v1/project/{projectId}/resources/{resourceId}/actions/{actionName}?';
    if (projectId === undefined || projectId === null) throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (resourceId === undefined || resourceId === null) throw new Error("The parameter 'resourceId' must be defined.");
    url_ = url_.replace('{resourceId}', encodeURIComponent('' + resourceId));
    if (actionName === undefined || actionName === null) throw new Error("The parameter 'actionName' must be defined.");
    url_ = url_.replace('{actionName}', encodeURIComponent('' + actionName));
    if (useCache === null) throw new Error("The parameter 'useCache' cannot be null.");
    else if (useCache !== undefined) url_ += 'useCache=' + encodeURIComponent('' + useCache) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUser_GetActionGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUser_GetActionGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processUser_GetActionGET2(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(null as any);
  }
}

export enum ChecksumValidationStatus {
  NOT_VALIDATED = 'NOT_VALIDATED',
  PENDING_RESPONSE_READ = 'PENDING_RESPONSE_READ',
  SUCCESSFUL = 'SUCCESSFUL',
  INVALID = 'INVALID',
}

export enum CoreChecksumAlgorithm {
  NONE = 'NONE',
  CRC32C = 'CRC32C',
  CRC32 = 'CRC32',
  SHA256 = 'SHA256',
  SHA1 = 'SHA1',
}

export interface ResponseMetadata {
  requestId: string | undefined;
  readonly metadata: { [key: string]: string } | undefined;
  checksumAlgorithm: CoreChecksumAlgorithm;
  checksumValidationStatus: ChecksumValidationStatus;
}

export interface BatchResultErrorEntry {
  code: string | undefined;
  id: string | undefined;
  message: string | undefined;
  senderFault: boolean;
}

export interface SendMessageBatchResponse {
  responseMetadata: ResponseMetadata;
  contentLength: number;
  httpStatusCode: HttpStatusCode;
  failed: BatchResultErrorEntry[] | undefined;
  successful: SendMessageBatchResultEntry[] | undefined;
}

export interface SendMessageBatchResultEntry {
  id: string | undefined;
  mD5OfMessageAttributes: string | undefined;
  mD5OfMessageBody: string | undefined;
  mD5OfMessageSystemAttributes: string | undefined;
  messageId: string | undefined;
  sequenceNumber: string | undefined;
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;
}

export interface ProblemDetailsException {
  targetSite: MethodBase;
  readonly message: string | undefined;
  readonly data: { [key: string]: any } | undefined;
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
  problemDetails: PulseProblemDetails;
}

export interface PulseProblemDetails {
  responseType: string | undefined;
  title: string | undefined;
  details: string | undefined;
  statusCode: number;
  errorDetails: { [key: string]: any } | undefined;
}

export interface UserErrorResponse {
  responseType: string | undefined;
  statusCode: number;
  title: string | undefined;
  details: string | undefined;
  errors: string[] | undefined;
}

export interface CacheInfo {
  objectFromCache: boolean;
  cacheKey: string | undefined;
}

export interface CacheWriteInfo {
  key: string | undefined;
  content: string | undefined;
  cacheTime: string | undefined;
}

export interface AccessPolicyItem {
  accessPolicyId: number;
  resourceFlagProjectPage: boolean | undefined;
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  actionId: number;
  actionName: string | undefined;
  resourceId: number;
  resourceName: string | undefined;
  resourceDescription: string | undefined;
  resourceTypeId: number;
  resourceTypeName: string | undefined;
  resourceImageLink: string | undefined;
  resourceSortOrder: number | undefined;
  roleId: number;
  roleIsInternal: boolean | undefined;
}

export interface ActionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface AdminPrivilege {
  id: number;
  name: string | undefined;
  description: string | undefined;
  lastUpdatedByUserId: number;
}

export interface Category {
  id: number;
  parentId: number;
  projectId: number;
  name: string | undefined;
  descriptionShort: string | undefined;
  descriptionLong: string | undefined;
  imageLink: string | undefined;
  sortOrder: number;
}

export interface CreateDefaultFilterForResourceResponseV3 {
  cacheInfo: CacheInfo;
  defaultFilterList: FilterUi[] | undefined;
}

export interface CreateFilterRequest {
  filterValues: FilterUiSelection[] | undefined;
  excludedFilterGroupCacheKeys: string[] | undefined;
}

export interface PageInfo_1OfRoleDTO {
  currentPage: number;
  pageSize: number;
  items: RoleDTO[] | undefined;
  totalItems: number;
}

export interface PageInfo_1OfUserBase {
  currentPage: number;
  pageSize: number;
  items: UserBase[] | undefined;
  totalItems: number;
}

export interface FilterCategoryDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  order: number;
}

export interface FilterDTO {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  filterType: string | undefined;
  filterCategoryId: number;
  filterGroupId: number;
  providerConnectionId: number;
  tablename: string | undefined;
  columns: Resource[] | undefined;
  order: number;
  hasAll: boolean | undefined;
  token: FilterTokenDTO[] | undefined;
  values: FilterValueDTO[] | undefined;
  valueRange: FilterValueRangeDTO;
  toolTip: string | undefined;
}

export interface FilterGroupDTO {
  id: number;
  name: string | undefined;
  sortOrder: number;
  showOnHeader: boolean;
  visibility: string | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
  interdependentFilterGroups: number[] | undefined;
  filters: FilterDTO[] | undefined;
  categories: FilterCategoryDTO[] | undefined;
}

export interface FilterTokenDTO {
  label: string | undefined;
  selection: FilterValueDTO[] | undefined;
}

export interface FilterValueDTO {
  value: string | undefined;
  label: string | undefined;
  column: string | undefined;
  isSelected: boolean;
  isDisabled: boolean;
  children: FilterValueDTO[] | undefined;
}

export interface FilterValueRangeDTO {
  min: string | undefined;
  max: string | undefined;
  column: string | undefined;
}

export interface GetAllRolesResponse {
  cacheInfo: CacheInfo;
  roles: PageInfo_1OfRoleDTO;
}

export interface GetIsGlobalAdminResponse {
  cacheInfo: CacheInfo;
  isGlobalAdmin: boolean;
}

export interface GetRoleResponse {
  cacheInfo: CacheInfo;
  roleDto: RoleDTO;
}

export interface GetUsersResponse {
  cacheInfo: CacheInfo;
  users: PageInfo_1OfUserBase;
}

export interface EMailAddress {
  mail: string | undefined;
  displayName: string | undefined;
}

export interface MailConfiguration {
  subject: string | undefined;
  body: string | undefined;
  isEncrypted: boolean;
  isSigned: boolean;
  isBodyHtml: boolean;
  attachments: string | undefined;
  displayName: string | undefined;
  replyTo: string | undefined;
}

export interface MailList {
  recipients: EMailAddress[] | undefined;
  copyReciepients: EMailAddress[] | undefined;
  blindCopyRecipients: EMailAddress[] | undefined;
  tag: string | undefined;
  customId: string | undefined;
  customIdType: string | undefined;
}

export interface MailSendRequest {
  projectId: number;
  mailConfiguration: MailConfiguration;
  mailList: MailList[] | undefined;
  contactData: any[] | undefined;
}

export interface MailSendResponse {
  success: boolean;
}

export interface ManagementInitDTO {
  users: UserBase[] | undefined;
  adminPrivileges: AdminPrivilege[] | undefined;
  resources: ResourceDTO[] | undefined;
  roles: RoleDTO[] | undefined;
  resourceTypes: ResourceTypeAccess[] | undefined;
}

export interface PermissionValueDTO {
  permissionSet: string | undefined;
  databaseColumn: string | undefined;
  databaseValue: string | undefined;
  rowLevelSecurityId: number;
  columnGroupId: number;
  columnDefinitionId: number;
}

export interface Project {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean;
}

export interface ProjectDetail {
  projectId: number;
  projectName: string | undefined;
  projectShortName: string | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface ProjectInitDTO {
  user: User;
  adminPrivilege: number[] | undefined;
  resources: ResourceDTO[] | undefined;
  resourceTypes: ResourceTypeAction[] | undefined;
  categories: Category[] | undefined;
  project: Project;
  tenantSettings: TenantSetting[] | undefined;
  isGlobalAdmin: boolean;
}

export interface ProjectPropertyDTO {
  id: number;
  projectId: number;
  name: string | undefined;
  value: string | undefined;
}

export interface ProviderConnection {
  id: number;
  providerType: string | undefined;
  sqlType: string | undefined;
  name: string | undefined;
  databaseName: string | undefined;
  server: string | undefined;
  proxy: string | undefined;
  awsSecret: string | undefined;
}

export interface ProviderConnectionDTO {
  id: number;
  name: string | undefined;
  resourceTypeId: number;
}

export interface Resource {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface ResourceAccess {
  resourceId: number;
  actions: number[] | undefined;
  roleId: number;
  roleName: string | undefined;
  isInternal: boolean;
  isGeneralAccess: boolean;
}

export interface ResourceAccessRequest {
  resourceId: number;
  actions: number[] | undefined;
}

export interface ResourceBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
}

export interface ResourceDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
}

export interface ResourceFull {
  id: number;
  name: string | undefined;
  description: string | undefined;
  imageLink: string | undefined;
  category: string | undefined;
  categoryId: number | undefined;
  subCategory: string | undefined;
  subCategoryId: number | undefined;
  resourceTypeId: number;
  flagProjectPage: boolean;
  projectId: number;
  sortOrder: number;
  createdOn: Date | undefined;
  createdByUserId: number;
  createdByUser: string | undefined;
  lastUpdatedOn: Date | undefined;
  lastUpdatedByUserId: number;
  lastUpdatedByUser: string | undefined;
  properties: { [key: string]: string } | undefined;
  fromCache: boolean;
  actions: string[] | undefined;
  childResourceIds: number[] | undefined;
  parentResourceIds: number[] | undefined;
  resourceToResourceProperties: { [key: string]: string } | undefined;
  childResources: ResourceFull[] | undefined;
}

export interface ResourceType {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
}

export interface ResourceTypeAccess {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: ActionDTO[] | undefined;
}

export interface ResourceTypeAccessGeneral {
  resourceTypeId: number;
  roleId: number;
  roleName: string | undefined;
  actions: number[] | undefined;
  categories: number[] | undefined;
}

export interface ResourceTypeAction {
  id: number;
  name: string | undefined;
  isInternal: boolean;
  isTopLevelResource: boolean;
  actions: string[] | undefined;
  categoryIds: number[] | undefined;
}

export interface ResourceTypeDefinition {
  id: number;
  resourceTypeId: number;
  propertyName: string | undefined;
  propertyTranslationKey: string | undefined;
  propertyType: string | undefined;
  defaultValue: string | undefined;
  valueList: string | undefined;
  visualizationType: string | undefined;
  relationalPropertyResourceTypeId: number;
  isMandatory: boolean;
  isSubResourceEagerlyLoaded: boolean;
  sortOrder: number;
}

export interface RoleAccess {
  roleId: number;
  resourceAccess: ResourceAccess[] | undefined;
}

export enum RoleColumnEnum {
  Id = 'Id',
  Name = 'Name',
  Description = 'Description',
}

export interface RoleDTO {
  id: number;
  name: string | undefined;
  description: string | undefined;
  projectId: number;
  isInternal: boolean | undefined;
}

export interface RoleFull {
  roleInfo: RoleDTO;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  userAttachedToThisRole: number[] | undefined;
}

export interface Measure {
  value: number;
  unit: string | undefined;
}

export interface SqlAnalyticResult {
  class: string | undefined;
  method: string | undefined;
  sqlExecutionTime: Measure;
  sql: string | undefined;
  info: string | undefined;
}

export interface SqlAnalyticResults {
  totalMeasure: Measure;
  results: SqlAnalyticResult[] | undefined;
}

export interface TenantSetting {
  setting: string | undefined;
  value: string | undefined;
}

export interface User {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  properties: { [key: string]: string } | undefined;
}

export interface UserBase {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
}

export interface UserFull {
  userBase: UserBase;
  adminPrivilege: number[] | undefined;
  resourceAccess: ResourceAccess[] | undefined;
  roleAccess: RoleAccess[] | undefined;
  properties: { [key: string]: string } | undefined;
  resourceTypeAccess: ResourceTypeAccessGeneral[] | undefined;
}

export interface UserProfile {
  userBase: UserBase;
  accessPolicy: AccessPolicyItem[] | undefined;
  adminPrivilege: number[] | undefined;
  resourceType: ResourceType[] | undefined;
  userProperties: { [key: string]: string } | undefined;
  projectProperties: { [key: string]: string } | undefined;
  fromCache: boolean;
}

export interface UserProjectAccess {
  id: number;
  externalId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  orgCode: string | undefined;
  isActive: boolean | undefined;
  isApiUser: boolean | undefined;
  projectAccess: ProjectDetail[] | undefined;
  fromCache: boolean;
  isGlobalAdmin: boolean;
}

export interface CreateFilterDefaultValues {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  defaultFilter: FilterGroupDTO[] | undefined;
}

export interface CreateFilterResponse {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  defaultFilter: FilterGroupDTOLight[] | undefined;
}

export interface FilterDTOLight {
  id: number;
  label: string | undefined;
  icon: string | undefined;
  filterGroupId: number;
  order: number;
  token: FilterTokenDTO[] | undefined;
  toolTip: string | undefined;
  values: FilterValueDTO[] | undefined;
  valueRange: FilterValueRangeDTO;
  filterType: string | undefined;
}

export interface FilterGroupDTOLight {
  id: number;
  name: string | undefined;
  sortOrder: number;
  showOnHeader: boolean;
  visibility: string | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
  interdependentFilterGroups: number[] | undefined;
  filters: FilterDTOLight[] | undefined;
  categories: FilterCategoryDTO[] | undefined;
}

export interface FilterGroupUi {
  cacheInfo: CacheInfo;
  id: number;
  name: string | undefined;
  sortOrder: number;
  visibility: FilterVisibility;
  filterList: FilterUi[] | undefined;
  icon: string | undefined;
  toolTip: string | undefined;
}

export interface FilterToken {
  label: string | undefined;
  selection: FilterValue[] | undefined;
}

export interface FilterUi {
  cacheInfo: CacheInfo;
  sqlAnalyticResult: SqlAnalyticResult;
  id: number;
  filterGroupId: number;
  filterType: string | undefined;
  values: FilterValueUi[] | undefined;
  token: FilterToken[] | undefined;
  valueRange: FilterValueRange;
  label: string | undefined;
  icon: string | undefined;
  sortOrder: number;
  toolTip: string | undefined;
}

export interface FilterUiSelection {
  id: number;
  filterGroupId: number;
  filterType: string | undefined;
  values: FilterValueUi[] | undefined;
}

export interface FilterValue {
  column: string | undefined;
  value: string | undefined;
  label: string | undefined;
  isDisabled: boolean;
  children: FilterValue[] | undefined;
}

export interface FilterValueRange {
  min: string | undefined;
  max: string | undefined;
  column: string | undefined;
}

export interface FilterValueUi {
  column: string | undefined;
  value: string | undefined;
  isDisabled: boolean;
  children: FilterValueUi[] | undefined;
}

export enum FilterVisibility {
  ShowInHeader = 'ShowInHeader',
  ShowInTabAsIcon = 'ShowInTabAsIcon',
  ShowInTab = 'ShowInTab',
}

export interface Country {
  countryNativeName: string | undefined;
  countryEnglishName: string | undefined;
  countryTag: string | undefined;
  countryTagThreeLetter: string | undefined;
}

export interface GetCountryListResponse {
  countries: Country[] | undefined;
}

export interface GetLanguageListResponse {
  languages: Language[] | undefined;
}

export interface Language {
  languageEnglishName: string | undefined;
  languageNativeName: string | undefined;
  languageTag: string | undefined;
  languageTagThreeLetter: string | undefined;
  languageParentTag: string | undefined;
}

export interface AddProjectLanguagePayload {
  language: string | undefined;
  sortOrder: number;
}

export interface AddProjectPayload {
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean | undefined;
  projectProperties: AddProjectPropertyPayload[] | undefined;
  resourceTypes: AddProjectResourceTypePayload[] | undefined;
  projectLanguages: AddProjectLanguagePayload[] | undefined;
  providerConnections: AddProjectProviderConnection[] | undefined;
}

export interface AddProjectPropertyPayload {
  name: string | undefined;
  value: string | undefined;
}

export interface AddProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface AddProjectProviderConnection {
  providerConnectionId: number;
  resourceTypeId: number;
}

export interface AddProjectResourceTypePayload {
  resourceTypeId: number;
}

export interface AddProjectResponse {
  project: Project2;
}

export interface AddProjectWithConfigurationPayload {
  configurationJson: string | undefined;
}

export interface AddProjectWithConfigurationResponse {
  project: Project2;
}

export interface GetProjectListResponse {
  projectList: Project2[] | undefined;
}

export interface GetProjectPropertyListResponse {
  projectPropertyList: ProjectProperty[] | undefined;
}

export interface GetProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface GetProjectResponse {
  project: Project2;
}

export interface Project2 {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean | undefined;
  projectProperties: ProjectProperty[] | undefined;
}

export interface ProjectProperty {
  id: number;
  projectId: number;
  name: string | undefined;
  value: string | undefined;
}

export interface UpdateProjectPayload {
  id: number;
  name: string | undefined;
  description: string | undefined;
  shortName: string | undefined;
  isPublic: boolean | undefined;
}

export interface UpdateProjectPropertyPayload {
  id: number;
  name: string | undefined;
  value: string | undefined;
}

export interface UpdateProjectPropertyResponse {
  projectProperty: ProjectProperty;
}

export interface UpdateProjectResponse {
  project: Project2;
}

export interface AddProviderConnectionPayload {
  providerType: string | undefined;
  sqlType: string | undefined;
  name: string | undefined;
  databaseName: string | undefined;
  server: string | undefined;
  awsSecret: string | undefined;
}

export interface AddProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface GetProviderConnectionListResponse {
  providerConnectionList: ProviderConnection2[] | undefined;
}

export interface GetProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface ProviderConnection2 {
  id: number;
  providerType: string | undefined;
  sqlType: string | undefined;
  name: string | undefined;
  databaseName: string | undefined;
  server: string | undefined;
  awsSecret: string | undefined;
}

export interface UpdateProviderConnectionResponse {
  providerConnection: ProviderConnection2;
}

export interface CachedObject {
  value: string | undefined;
}

export interface AddDataIntoCacheNew {
  content: string | undefined;
  cacheTime: string | undefined;
}

export interface AddDataIntoCacheResponse {}

export interface DeleteAllCachesForResourceResponse {
  amountOfRemovedKeys: number;
}

export interface DeleteDataFromCacheResponse {}

export interface DeleteProjectCacheForModuleResponse {
  amountOfRemovedKeys: number;
}

export interface DeleteProjectCacheResponse {
  amountOfRemovedKeys: number;
}

export interface GetAllProjectCacheKeysResponse {
  cacheKeys: string[] | undefined;
}

export interface GetDataFromCacheResponse {
  value: string | undefined;
}

export interface FilterController_CreateFilterUiForResourceResponse {
  cacheInfo: CacheInfo;
  sqlAnalyticResults: SqlAnalyticResults;
  filterGroupList: FilterGroupUi[] | undefined;
}

export interface ManagementInitDTOV2 {
  adminPrivileges: AdminPrivilege[] | undefined;
  resources: ResourceDTO[] | undefined;
  resourceTypes: ResourceTypeAccess[] | undefined;
}

export interface PreCachingPayload {
  projectId: number;
  amountOfUsers: number;
}

export interface DeleteRoleGeneralAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface DeleteRoleResourceAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface UpdateRoleGeneralAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface UpdateRoleResourceAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface UpdateRoleResponse {
  roleDto: RoleDTO;
}

export interface BreadCrumb {
  code: string | undefined;
  name: string | undefined;
  order: number;
}

export interface Employee {
  firstName: string | undefined;
  lastName: string | undefined;
  fullName: string | undefined;
  email: string | undefined;
  gid: string | undefined;
  positionShort: string | undefined;
  isActing: number;
  isHead: number;
}

export interface Organization {
  orgCode: string | undefined;
  orgName: string | undefined;
  orgUnit: string | undefined;
  orgType: string | undefined;
  orgClass: string | undefined;
  employeesTotal: string | undefined;
  employeesNode: string | undefined;
  isLeaf: string | undefined;
  order: string | undefined;
  team: Employee[] | undefined;
}

export interface Parent {
  orgCode: string | undefined;
  orgName: string | undefined;
}

export interface TeamRequestData {
  orgCode: string | undefined;
}

export interface TeamResponse {
  cacheInfo: CacheInfo;
  breadCrumbs: BreadCrumb[] | undefined;
  parent: Parent;
  current: Organization;
  children: Organization[] | undefined;
}

export interface SetupProjectRequest {
  surveySettings: SurveySettings;
}

export interface SetupProjectResponse {}

export interface SurveySettings {
  surveyType: SurveyType;
  landingPageUrl: string | undefined;
  themeId: number;
  contactEmail: string | undefined;
  pagePersistancy: number;
}

export enum SurveyType {
  OpenAccess = 'OpenAccess',
  AnonymousEmployee = 'AnonymousEmployee',
  InvitationOnly = 'InvitationOnly',
}

export interface PageDefinition {
  search: string | undefined;
  pageSize: number;
  page: number;
}

export interface Page_1OfResourceDTO {
  count: number;
  items: ResourceDTO[] | undefined;
  definition: PageDefinition;
}

export interface Page_1OfResourceFull {
  count: number;
  items: ResourceFull[] | undefined;
  definition: PageDefinition;
}

export interface DeleteGeneralAccessResponse {
  deletedAccessPolicies: number[] | undefined;
}

export interface GeneralAccessFor {
  actionIds: number[] | undefined;
  categoryIds: number[] | undefined;
}

export interface UpdateGeneralAccessResponse {
  deletedAccessPoliciesToRoleIds: number[] | undefined;
  deletedAccessPolicies: number[] | undefined;
  insertedAccessPolicyIds: number[] | undefined;
  insertedAccessPoliciesToRoleIds: number[] | undefined;
}

export interface ResourceAccessFor {
  actionIds: number[] | undefined;
  resourceId: number;
}

export interface AddRoleResponse {
  roleDto: RoleDTO;
}

export interface AddRoleToAccessPolicyResponse {
  isSuccess: boolean;
}

export interface DeleteRoleFromAccessPolicyResponse {
  isSuccess: boolean;
}

export interface DeleteRoleResponse {
  isSuccess: boolean;
}

export interface GetRoleFullResponse {
  cacheInfo: CacheInfo;
  roleFull: RoleFull;
}

export interface GetUsersForRoleResponse {
  cacheInfo: CacheInfo;
  roleUsers: PageInfo_1OfUserBase;
}

export interface AddProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface AddProjectLanguageResponse {
  cacheInfo: CacheInfo;
}

export interface DeleteProjectLanguageResponse {
  cacheInfo: CacheInfo;
  deletedLanguages: string | undefined;
}

export interface GetAllProjectLanguageResponse {
  cacheInfo: CacheInfo;
  languages: ProjectLanguage[] | undefined;
}

export interface ProjectLanguage {
  id: number;
  language: string | undefined;
  isS3Deployed: number;
  sortOrder: number;
  lastUpdatedByUserId: number;
}

export interface UpdateProjectLanguageRequest {
  language: string | undefined;
  sortOrder: number;
}

export interface UpdateProjectLanguageResponse {}

export interface AddOrUpdateProjectTranslationRequest {
  translations: ProjectTranslation[] | undefined;
}

export interface AddOrUpdateProjectTranslationResponse {
  success: boolean;
}

export interface GetAllProjectTranslationResponse {
  cacheInfo: CacheInfo;
  translations: { [key: string]: string } | undefined;
}

export interface ProjectTranslation {
  key: string | undefined;
  value: string | undefined;
  area: string | undefined;
}

export interface AddOrUpdateResourceTranslationByKeyRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationRequest {
  key: string | undefined;
  translations: ResourceTranslation[] | undefined;
}

export interface AddOrUpdateResourceTranslationResponse {
  itemsAffected: number;
}

export interface GetAllResourceTranslationResponse {
  cacheInfo: CacheInfo;
  translations: ResourceTranslation[] | undefined;
}

export interface ResourceTranslation {
  value: string | undefined;
  area: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationItem {
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  translation: string | undefined;
  language: string | undefined;
}

export interface AddOrUpdateTranslationResponse {
  itemsAffected: number;
}

export interface AddOrUpdateTranslationsRequest {
  translations: AddOrUpdateTranslationItem[] | undefined;
}

export interface DeleteAllLanguagesTranslationItem {
  area: string | undefined;
  translationKey: string | undefined;
  resourceId: number;
}

export interface DeleteAllLanguagesTranslationsRequest {
  translations: DeleteAllLanguagesTranslationItem[] | undefined;
}

export interface DeleteTranslationsResponse {
  affectedItems: number;
}

export interface ExportTranslationsRequest {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  fileType: string | undefined;
}

export interface GetJoinedTranslationsResponse {
  joinedTranslations: JoinedTranslation[] | undefined;
}

export interface ImportTranslationsResponse {
  affectedLanguages: string[] | undefined;
}

export interface JoinedTranslation {
  sourceLanguage: string | undefined;
  targetLanguage: string | undefined;
  resourceId: number;
  area: string | undefined;
  translationKey: string | undefined;
  sourceTranslation: string | undefined;
  targetTranslation: string | undefined;
}

export interface AddUserResponse {
  cacheInfo: CacheInfo;
  user: UserBase;
}

export interface DeleteUserResponse {
  cacheInfo: CacheInfo;
  id: number;
}

export enum UserColumnEnum {
  Id = 'Id',
  ExternalId = 'ExternalId',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
}

export interface GetUserResponse {
  cacheInfo: CacheInfo;
  user: UserBase;
}

export interface Exception {
  targetSite: MethodBase;
  readonly message: string | undefined;
  readonly data: { [key: string]: any } | undefined;
  innerException: Exception;
  helpLink: string | undefined;
  source: string | undefined;
  hResult: number;
  readonly stackTrace: string | undefined;
}

export interface IntPtr {}

export interface ModuleHandle {
  readonly mdStreamVersion: number;
}

export enum HttpStatusCode {
  Continue = 'Continue',
  SwitchingProtocols = 'SwitchingProtocols',
  Processing = 'Processing',
  EarlyHints = 'EarlyHints',
  OK = 'OK',
  Created = 'Created',
  Accepted = 'Accepted',
  NonAuthoritativeInformation = 'NonAuthoritativeInformation',
  NoContent = 'NoContent',
  ResetContent = 'ResetContent',
  PartialContent = 'PartialContent',
  MultiStatus = 'MultiStatus',
  AlreadyReported = 'AlreadyReported',
  IMUsed = 'IMUsed',
  MultipleChoices = 'MultipleChoices',
  MovedPermanently = 'MovedPermanently',
  Found = 'Found',
  SeeOther = 'SeeOther',
  NotModified = 'NotModified',
  UseProxy = 'UseProxy',
  Unused = 'Unused',
  TemporaryRedirect = 'TemporaryRedirect',
  PermanentRedirect = 'PermanentRedirect',
  BadRequest = 'BadRequest',
  Unauthorized = 'Unauthorized',
  PaymentRequired = 'PaymentRequired',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  MethodNotAllowed = 'MethodNotAllowed',
  NotAcceptable = 'NotAcceptable',
  ProxyAuthenticationRequired = 'ProxyAuthenticationRequired',
  RequestTimeout = 'RequestTimeout',
  Conflict = 'Conflict',
  Gone = 'Gone',
  LengthRequired = 'LengthRequired',
  PreconditionFailed = 'PreconditionFailed',
  RequestEntityTooLarge = 'RequestEntityTooLarge',
  RequestUriTooLong = 'RequestUriTooLong',
  UnsupportedMediaType = 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
  ExpectationFailed = 'ExpectationFailed',
  MisdirectedRequest = 'MisdirectedRequest',
  UnprocessableEntity = 'UnprocessableEntity',
  Locked = 'Locked',
  FailedDependency = 'FailedDependency',
  UpgradeRequired = 'UpgradeRequired',
  PreconditionRequired = 'PreconditionRequired',
  TooManyRequests = 'TooManyRequests',
  RequestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons = 'UnavailableForLegalReasons',
  InternalServerError = 'InternalServerError',
  NotImplemented = 'NotImplemented',
  BadGateway = 'BadGateway',
  ServiceUnavailable = 'ServiceUnavailable',
  GatewayTimeout = 'GatewayTimeout',
  HttpVersionNotSupported = 'HttpVersionNotSupported',
  VariantAlsoNegotiates = 'VariantAlsoNegotiates',
  InsufficientStorage = 'InsufficientStorage',
  LoopDetected = 'LoopDetected',
  NotExtended = 'NotExtended',
  NetworkAuthenticationRequired = 'NetworkAuthenticationRequired',
}

export interface Assembly {
  readonly definedTypes: TypeInfo[] | undefined;
  readonly exportedTypes: Type[] | undefined;
  readonly codeBase: string | undefined;
  entryPoint: MethodInfo;
  readonly fullName: string | undefined;
  readonly imageRuntimeVersion: string | undefined;
  readonly isDynamic: boolean;
  readonly location: string | undefined;
  readonly reflectionOnly: boolean;
  readonly isCollectible: boolean;
  readonly isFullyTrusted: boolean;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly escapedCodeBase: string | undefined;
  manifestModule: Module;
  readonly modules: Module[] | undefined;
  readonly globalAssemblyCache: boolean;
  readonly hostContext: number;
  securityRuleSet: SecurityRuleSet;
}

export enum CallingConventions {
  Standard = 'Standard',
  VarArgs = 'VarArgs',
  Any = 'Any',
  HasThis = 'HasThis',
  ExplicitThis = 'ExplicitThis',
}

export interface ConstructorInfo {
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
}

export interface CustomAttributeData {
  attributeType: Type;
  constructor: ConstructorInfo;
  readonly constructorArguments: CustomAttributeTypedArgument[] | undefined;
  readonly namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export interface CustomAttributeNamedArgument {
  memberInfo: MemberInfo;
  typedValue: CustomAttributeTypedArgument;
  readonly memberName: string | undefined;
  readonly isField: boolean;
}

export interface CustomAttributeTypedArgument {
  argumentType: Type;
  value: any | undefined;
}

export enum EventAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
}

export interface EventInfo {
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: EventAttributes;
  readonly isSpecialName: boolean;
  addMethod: MethodInfo;
  removeMethod: MethodInfo;
  raiseMethod: MethodInfo;
  readonly isMulticast: boolean;
  eventHandlerType: Type;
}

export enum FieldAttributes {
  PrivateScope = 'PrivateScope',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  FieldAccessMask = 'FieldAccessMask',
  Static = 'Static',
  InitOnly = 'InitOnly',
  Literal = 'Literal',
  NotSerialized = 'NotSerialized',
  HasFieldRVA = 'HasFieldRVA',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasFieldMarshal = 'HasFieldMarshal',
  PinvokeImpl = 'PinvokeImpl',
  HasDefault = 'HasDefault',
  ReservedMask = 'ReservedMask',
}

export interface FieldInfo {
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  attributes: FieldAttributes;
  fieldType: Type;
  readonly isInitOnly: boolean;
  readonly isLiteral: boolean;
  readonly isNotSerialized: boolean;
  readonly isPinvokeImpl: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  fieldHandle: RuntimeFieldHandle;
}

export enum GenericParameterAttributes {
  None = 'None',
  Covariant = 'Covariant',
  Contravariant = 'Contravariant',
  VarianceMask = 'VarianceMask',
  ReferenceTypeConstraint = 'ReferenceTypeConstraint',
  NotNullableValueTypeConstraint = 'NotNullableValueTypeConstraint',
  DefaultConstructorConstraint = 'DefaultConstructorConstraint',
  SpecialConstraintMask = 'SpecialConstraintMask',
}

export interface ICustomAttributeProvider {}

export interface MemberInfo {
  memberType: MemberTypes;
  declaringType: Type;
  reflectedType: Type;
  readonly name: string | undefined;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
}

export enum MemberTypes {
  Constructor = 'Constructor',
  Event = 'Event',
  Field = 'Field',
  Method = 'Method',
  Property = 'Property',
  TypeInfo = 'TypeInfo',
  Custom = 'Custom',
  NestedType = 'NestedType',
  All = 'All',
}

export enum MethodAttributes {
  ReuseSlot = 'ReuseSlot',
  Private = 'Private',
  FamANDAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamORAssem = 'FamORAssem',
  Public = 'Public',
  MemberAccessMask = 'MemberAccessMask',
  UnmanagedExport = 'UnmanagedExport',
  Static = 'Static',
  Final = 'Final',
  Virtual = 'Virtual',
  HideBySig = 'HideBySig',
  NewSlot = 'NewSlot',
  CheckAccessOnOverride = 'CheckAccessOnOverride',
  Abstract = 'Abstract',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  PinvokeImpl = 'PinvokeImpl',
  HasSecurity = 'HasSecurity',
  RequireSecObject = 'RequireSecObject',
  ReservedMask = 'ReservedMask',
}

export interface MethodBase {
  memberType: MemberTypes;
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
  IL = 'IL',
  Native = 'Native',
  OPTIL = 'OPTIL',
  Runtime = 'Runtime',
  Unmanaged = 'Unmanaged',
  NoInlining = 'NoInlining',
  ForwardRef = 'ForwardRef',
  Synchronized = 'Synchronized',
  NoOptimization = 'NoOptimization',
  PreserveSig = 'PreserveSig',
  AggressiveInlining = 'AggressiveInlining',
  AggressiveOptimization = 'AggressiveOptimization',
  InternalCall = 'InternalCall',
  MaxMethodImplVal = 'MaxMethodImplVal',
}

export interface MethodInfo {
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  attributes: MethodAttributes;
  methodImplementationFlags: MethodImplAttributes;
  callingConvention: CallingConventions;
  readonly isAbstract: boolean;
  readonly isConstructor: boolean;
  readonly isFinal: boolean;
  readonly isHideBySig: boolean;
  readonly isSpecialName: boolean;
  readonly isStatic: boolean;
  readonly isVirtual: boolean;
  readonly isAssembly: boolean;
  readonly isFamily: boolean;
  readonly isFamilyAndAssembly: boolean;
  readonly isFamilyOrAssembly: boolean;
  readonly isPrivate: boolean;
  readonly isPublic: boolean;
  readonly isConstructedGenericMethod: boolean;
  readonly isGenericMethod: boolean;
  readonly isGenericMethodDefinition: boolean;
  readonly containsGenericParameters: boolean;
  methodHandle: RuntimeMethodHandle;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  memberType: MemberTypes;
  returnParameter: ParameterInfo;
  returnType: Type;
  returnTypeCustomAttributes: ICustomAttributeProvider;
}

export interface Module {
  assembly: Assembly;
  readonly fullyQualifiedName: string | undefined;
  readonly name: string | undefined;
  readonly mdStreamVersion: number;
  readonly moduleVersionId: string;
  readonly scopeName: string | undefined;
  moduleHandle: ModuleHandle;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly metadataToken: number;
}

export enum ParameterAttributes {
  None = 'None',
  In = 'In',
  Out = 'Out',
  Lcid = 'Lcid',
  Retval = 'Retval',
  Optional = 'Optional',
  HasDefault = 'HasDefault',
  HasFieldMarshal = 'HasFieldMarshal',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface ParameterInfo {
  attributes: ParameterAttributes;
  member: MemberInfo;
  readonly name: string | undefined;
  parameterType: Type;
  readonly position: number;
  readonly isIn: boolean;
  readonly isLcid: boolean;
  readonly isOptional: boolean;
  readonly isOut: boolean;
  readonly isRetval: boolean;
  readonly defaultValue: any | undefined;
  readonly rawDefaultValue: any | undefined;
  readonly hasDefaultValue: boolean;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly metadataToken: number;
}

export enum PropertyAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  HasDefault = 'HasDefault',
  Reserved2 = 'Reserved2',
  Reserved3 = 'Reserved3',
  Reserved4 = 'Reserved4',
  ReservedMask = 'ReservedMask',
}

export interface PropertyInfo {
  readonly name: string | undefined;
  declaringType: Type;
  reflectedType: Type;
  module: Module;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  memberType: MemberTypes;
  propertyType: Type;
  attributes: PropertyAttributes;
  readonly isSpecialName: boolean;
  readonly canRead: boolean;
  readonly canWrite: boolean;
  getMethod: MethodInfo;
  setMethod: MethodInfo;
}

export enum TypeAttributes {
  NotPublic = 'NotPublic',
  Public = 'Public',
  NestedPublic = 'NestedPublic',
  NestedPrivate = 'NestedPrivate',
  NestedFamily = 'NestedFamily',
  NestedAssembly = 'NestedAssembly',
  NestedFamANDAssem = 'NestedFamANDAssem',
  NestedFamORAssem = 'NestedFamORAssem',
  SequentialLayout = 'SequentialLayout',
  ExplicitLayout = 'ExplicitLayout',
  LayoutMask = 'LayoutMask',
  Interface = 'Interface',
  Abstract = 'Abstract',
  Sealed = 'Sealed',
  SpecialName = 'SpecialName',
  RTSpecialName = 'RTSpecialName',
  Import = 'Import',
  Serializable = 'Serializable',
  WindowsRuntime = 'WindowsRuntime',
  UnicodeClass = 'UnicodeClass',
  AutoClass = 'AutoClass',
  CustomFormatClass = 'CustomFormatClass',
  HasSecurity = 'HasSecurity',
  ReservedMask = 'ReservedMask',
  BeforeFieldInit = 'BeforeFieldInit',
  CustomFormatMask = 'CustomFormatMask',
}

export interface TypeInfo {
  readonly name: string | undefined;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[] | undefined;
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
  readonly genericTypeParameters: Type[] | undefined;
  readonly declaredConstructors: ConstructorInfo[] | undefined;
  readonly declaredEvents: EventInfo[] | undefined;
  readonly declaredFields: FieldInfo[] | undefined;
  readonly declaredMembers: MemberInfo[] | undefined;
  readonly declaredMethods: MethodInfo[] | undefined;
  readonly declaredNestedTypes: TypeInfo[] | undefined;
  readonly declaredProperties: PropertyInfo[] | undefined;
  readonly implementedInterfaces: Type[] | undefined;
}

export enum LayoutKind {
  Sequential = 'Sequential',
  Explicit = 'Explicit',
  Auto = 'Auto',
}

export interface StructLayoutAttribute {
  readonly typeId: any | undefined;
  value: LayoutKind;
}

export interface RuntimeFieldHandle {
  value: IntPtr;
}

export interface RuntimeMethodHandle {
  value: IntPtr;
}

export interface RuntimeTypeHandle {
  value: IntPtr;
}

export enum SecurityRuleSet {
  None = 'None',
  Level1 = 'Level1',
  Level2 = 'Level2',
}

export interface Type {
  readonly name: string | undefined;
  readonly customAttributes: CustomAttributeData[] | undefined;
  readonly isCollectible: boolean;
  readonly metadataToken: number;
  readonly isInterface: boolean;
  memberType: MemberTypes;
  readonly namespace: string | undefined;
  readonly assemblyQualifiedName: string | undefined;
  readonly fullName: string | undefined;
  assembly: Assembly;
  module: Module;
  readonly isNested: boolean;
  declaringType: Type;
  declaringMethod: MethodBase;
  reflectedType: Type;
  underlyingSystemType: Type;
  readonly isTypeDefinition: boolean;
  readonly isArray: boolean;
  readonly isByRef: boolean;
  readonly isPointer: boolean;
  readonly isConstructedGenericType: boolean;
  readonly isGenericParameter: boolean;
  readonly isGenericTypeParameter: boolean;
  readonly isGenericMethodParameter: boolean;
  readonly isGenericType: boolean;
  readonly isGenericTypeDefinition: boolean;
  readonly isSZArray: boolean;
  readonly isVariableBoundArray: boolean;
  readonly isByRefLike: boolean;
  readonly hasElementType: boolean;
  readonly genericTypeArguments: Type[] | undefined;
  readonly genericParameterPosition: number;
  genericParameterAttributes: GenericParameterAttributes;
  attributes: TypeAttributes;
  readonly isAbstract: boolean;
  readonly isImport: boolean;
  readonly isSealed: boolean;
  readonly isSpecialName: boolean;
  readonly isClass: boolean;
  readonly isNestedAssembly: boolean;
  readonly isNestedFamANDAssem: boolean;
  readonly isNestedFamily: boolean;
  readonly isNestedFamORAssem: boolean;
  readonly isNestedPrivate: boolean;
  readonly isNestedPublic: boolean;
  readonly isNotPublic: boolean;
  readonly isPublic: boolean;
  readonly isAutoLayout: boolean;
  readonly isExplicitLayout: boolean;
  readonly isLayoutSequential: boolean;
  readonly isAnsiClass: boolean;
  readonly isAutoClass: boolean;
  readonly isUnicodeClass: boolean;
  readonly isCOMObject: boolean;
  readonly isContextful: boolean;
  readonly isEnum: boolean;
  readonly isMarshalByRef: boolean;
  readonly isPrimitive: boolean;
  readonly isValueType: boolean;
  readonly isSignatureType: boolean;
  readonly isSecurityCritical: boolean;
  readonly isSecuritySafeCritical: boolean;
  readonly isSecurityTransparent: boolean;
  structLayoutAttribute: StructLayoutAttribute;
  typeInitializer: ConstructorInfo;
  typeHandle: RuntimeTypeHandle;
  readonly guid: string;
  baseType: Type;
  readonly isSerializable: boolean;
  readonly containsGenericParameters: boolean;
  readonly isVisible: boolean;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
